export const translations = {
  en: {
    // Navigation
    home: 'Home',
    manufacturers: 'Manufacturers',
    products: 'Products',
    more: 'More',
    inquiries: 'Inquiries',
    dashboard: 'Dashboard',
    startSourcing: 'Start Sourcing',

    // Homepage
    heroTagline: 'Source directly from Egypt\'s verified factories',
    heroTitle: 'Source Directly from',
    heroTitleHighlight: 'Egypt\'s Verified Factories',
    heroSubtitle: 'From Ancient Linen to Modern Excellence',
    heroSubtitle2: '3000+ Years of Textile Mastery',
    searchPlaceholder: 'Search manufacturers, products, or categories...',
    searchButton: 'Search',
    exploreCategories: 'Explore Categories',

    // Hero Era Badges
    ancientEgypt: 'Ancient Egypt - 3000 BC',
    ancientEgyptDesc: 'Pioneers of fine linen weaving',
    traditionalCraftsmanship: 'Traditional Craftsmanship',
    traditionalCraftsmanshipDesc: 'Generations of textile mastery',
    modernExcellence: 'Modern Excellence',
    modernExcellenceDesc: 'World-class manufacturing',
    worldClassManufacturing: 'World-class manufacturing',

    // Egyptian Textile Categories
    yarnSpinning: 'Yarn & Spinning',
    yarnSpinningDesc: 'Premium Egyptian cotton yarn and spinning services',
    fabricsTextiles: 'Fabrics & Textiles',
    fabricsTextilesDesc: 'Technical fabrics and premium textiles',
    accessoriesTrims: 'Accessories & Trims',
    accessoriesTrimsDesc: 'Textile accessories, buttons, zippers and trims',
    machineryEquipment: 'Machinery & Equipment',
    machineryEquipmentDesc: 'Textile manufacturing equipment and machinery',
    textileMachinery: 'Textile Machinery',
    textileMachineryDesc: 'Spinning machines, weaving looms, dyeing equipment, and textile production machinery',

    // Visitor Actions
    whatWouldYouLikeToDo: 'What would you like to do?',
    browseManufacturersAction: 'Browse Manufacturers',
    browseProductsAction: 'Browse Products',
    sendInquiryAction: 'Send Inquiry',
    orSearchDirectly: 'Or search directly:',

    // Featured Manufacturers
    featuredManufacturers: 'Featured Verified Manufacturers',
    featuredManufacturersDesc: 'Connect with top-rated manufacturers who have demonstrated excellence in quality, reliability, and customer service.',
    verified: 'Verified',
    productsCount: 'Products',
    responseRate: 'Response Rate',
    viewProfile: 'View Profile',
    viewAllManufacturers: 'View All Manufacturers',

    // Categories
    industryCategories: 'Industry Categories',
    categoriesDesc: 'Explore our comprehensive range of textile and manufacturing categories. Find exactly what you need with specialized filtering.',
    totalCategories: 'Total Categories',
    totalProductsInCategories: 'Total Products',
    trending: 'Trending',
    allCategories: 'All Categories',
    searchCategories: 'Search categories...',
    exploreCategory: 'Explore Category',
    subcategories: 'Subcategories',

    // Manufacturer Directory
    manufacturerDirectory: 'Manufacturer Directory',
    manufacturerDirectoryDesc: 'Connect with verified Egyptian textile manufacturers and suppliers. Find the perfect partner for your business needs.',
    totalManufacturers: 'Total Manufacturers',
    verifiedCompanies: 'Verified Companies',
    activeProducts: 'Active Products',
    monthlyInquiries: 'Monthly Inquiries',
    searchManufacturers: 'Search manufacturers...',
    allLocations: 'All Locations',
    showing: 'Showing',
    manufacturer: 'manufacturer',
    manufacturers_plural: 'manufacturers',
    location: 'Location',
    since: 'Since',
    staff: 'Staff',
    rating: 'rating',
    certifications: 'Certifications',
    noManufacturersFound: 'No manufacturers found',
    tryAdjustingFilters: 'Try adjusting your search criteria or filters',
    areYouManufacturer: 'Are you a manufacturer?',
    registerFactoryDesc: 'Register your factory to showcase products and connect with global buyers',
    registerYourFactory: 'Register Your Factory',

    // Product Catalog
    productCatalog: 'Product Catalog',
    productCatalogDesc: 'Browse our extensive collection of verified textile products from trusted manufacturers.',
    filters: 'Filters',
    sortBy: 'Sort By',
    relevance: 'Relevance',
    priceLowToHigh: 'Price: Low to High',
    priceHighToLow: 'Price: High to Low',
    newest: 'Newest',
    searchProducts: 'Search products...',
    minOrder: 'Min Order',
    sendInquiry: 'Send Inquiry',

    // Sign In
    signIn: 'Sign In',
    welcomeBack: 'Welcome Back',
    signInDesc: 'Sign in to access your vendor dashboard and manage your business operations.',
    email: 'Email',
    password: 'Password',
    selectRole: 'Select Your Role',
    owner: 'Owner',
    admin: 'Admin',
    ownerDesc: 'Full access to all features',
    adminDesc: 'Manage operations',

    // Common
    category: 'Category',
    description: 'Description',
    noResultsFound: 'No results found',
    loading: 'Loading...',
    error: 'Error',
    success: 'Success',
    cancel: 'Cancel',
    save: 'Save',
    delete: 'Delete',
    edit: 'Edit',
    view: 'View',

    // Vendor Dashboard
    vendorDashboard: 'Vendor Dashboard',
    dashboardSubtitle: 'Manage your profile, products, and inquiries from one centralized location',
    overview: 'Overview',
    analytics: 'Analytics',
    profile: 'Profile',
    settings: 'Settings',
    navigation: 'Navigation',
    quickActions: 'Quick Actions',
    needHelp: 'Need Help?',
    helpDescription: 'Check our documentation or contact support',
    viewDocs: 'View Docs',

    // Dashboard Stats
    totalProducts: 'Total Products',
    activeInquiries: 'Active Inquiries',
    profileViews: 'Profile Views',
    profileCompletion: 'Profile Completion',
    completeProfile: 'Complete Profile',
    completeProfileDesc: 'Complete your profile to increase visibility',
    missingInformation: 'Missing Information:',

    // Performance & Notifications
    performanceAnalytics: 'Performance Analytics',
    notifications: 'Notifications',
    all: 'All',
    approvals: 'Approvals',
    system: 'System',
    messages: 'Messages',
    noNotificationsFound: 'No notifications found',
    showLess: 'Show Less',
    viewAll: 'View All',

    // Inquiries Table
    recentInquiries: 'Recent Inquiries',
    visitor: 'Visitor',
    product: 'Product',
    quantity: 'Quantity',
    date: 'Date',
    priority: 'Priority',
    status: 'Status',
    action: 'Action',
    viewDetails: 'View Details',
    high: 'High',
    medium: 'Medium',
    low: 'Low',
    pending: 'Pending',
    responded: 'Responded',
    closed: 'Closed',

    // Product Management
    productCatalogManager: 'Product Catalog',
    addProduct: 'Add Product',
    allStatus: 'All Status',
    active: 'Active',
    inactive: 'Inactive',
    stock: 'Stock',
    price: 'Price',

    // Quick Actions
    addNewProduct: 'Add New Product',
    addNewProductDesc: 'List a new product in your catalog',
    manageInquiries: 'Manage Inquiries',
    manageInquiriesDesc: 'View and respond to buyer inquiries',
    updateProfile: 'Update Profile',
    updateProfileDesc: 'Complete your company profile',

    // CTA Section
    ctaTitle: 'Ready to Transform Your Sourcing Strategy?',
    ctaSubtitle: 'Join thousands of procurement professionals who trust EgypTex Gateway for reliable, data-driven manufacturer connections.',
    browseManufacturers: 'Browse Manufacturers',
    exploreProducts: 'Explore Products',
    trustedBy: 'Trusted by leading companies worldwide',
    fortune500: 'Fortune 500 Companies',
    smeManufacturers: 'SME Manufacturers',
    internationalTraders: 'International Traders',

    // Footer
    connectingManufacturers: 'Connecting verified manufacturers with global buyers through data-driven precision.',
    platform: 'Platform',
    resources: 'Resources',
    company: 'Company',
    legal: 'Legal',
    sourcingGuide: 'Sourcing Guide',
    qualityStandards: 'Quality Standards',
    verificationProcess: 'Verification Process',
    helpCenter: 'Help Center',
    aboutUs: 'About Us',
    contact: 'Contact',
    blog: 'Blog',
    privacyPolicy: 'Privacy Policy',
    termsOfService: 'Terms of Service',
    cookiePolicy: 'Cookie Policy',
    gdprCompliance: 'GDPR Compliance',
    allRightsReserved: 'All rights reserved',
    isoCertified: 'ISO 9001 Certified',
    gdprCompliant: 'GDPR Compliant',

    // Success Stories
    successStories: 'Success Stories',
    successStoriesDesc: 'Real results from businesses that transformed their sourcing strategy with EgypTex Gateway.',
    challenge: 'Challenge',
    solution: 'Solution',
    results: 'Results',

    // Trust Indicators
    trustSecurity: 'Trust & Security',
    trustSecurityDesc: 'Your sourcing success is built on our commitment to transparency, security, and quality assurance.',
    verifiedManufacturers: 'Verified Manufacturers',
    verifiedManufacturersDesc: 'Every manufacturer undergoes rigorous verification including business registration, certifications, and capability assessments.',
    securePlatform: 'Secure Platform',
    securePlatformDesc: 'Enterprise-grade security with SSL encryption, GDPR compliance, and secure data handling protocols.',
    qualityAssurance: 'Quality Assurance',
    qualityAssuranceDesc: 'ISO 9001 certified platform with continuous monitoring and quality control processes.',
    globalStandards: 'Global Standards',
    globalStandardsDesc: 'Compliance with international trade regulations and industry-specific quality standards.',
    platformCertifications: 'Platform Certifications & Compliance',
    platformIso9001: 'ISO 9001:2015',
    platformSslSecured: 'SSL Secured',
    platformSoc2: 'SOC 2 Type II',

    // Platform Metrics
    activeManufacturers: 'Active Manufacturers',
    productListings: 'Product Listings',
    successfulConnections: 'Successful Connections',
    averageResponseTime: 'Average Response Time',

    // Heritage Timeline
    ourHeritage: 'Our Heritage',
    legacyWovenThroughTime: 'A Legacy Woven Through Time',
    heritageTimelineDesc: 'From ancient looms to modern factories, Egypt\'s textile tradition spans millennia',
    ancientEgyptEra: 'Ancient Egypt',
    ancientEgyptYear: '3000 BC',
    birthOfFineTextiles: 'The Birth of Fine Textiles',
    birthOfFineTextilesDesc: 'Egyptian artisans pioneered linen weaving techniques that produced fabrics so fine they were treasured across ancient civilizations. Pharaohs wore linen as a symbol of purity and light.',
    traditionalCraftsmanshipEra: 'Traditional Craftsmanship',
    traditionalCraftsmanshipYear: '1000 - 1900 AD',
    generationsOfMastery: 'Generations of Mastery',
    generationsOfMasteryDesc: 'Through centuries, Egyptian craftsmen refined their skills, passing down techniques from generation to generation. Hand-spinning and weaving remained an art form of precision and patience.',
    modernEra: 'Modern Era',
    modernEraYear: '1900 - Present',
    globalExcellenceManufacturing: 'Global Excellence in Manufacturing',
    globalExcellenceManufacturingDesc: 'Egyptian long-staple cotton became legendary worldwide. Today, we combine ancient craftsmanship with cutting-edge technology to produce textiles that meet the highest international standards.',

    // Egyptian Cotton Story
    theGoldStandard: 'The Gold Standard',
    egyptianLongStapleCotton: 'Egyptian Long-Staple Cotton',
    egyptianCottonDesc: 'Grown in the fertile Nile Delta, our cotton is renowned worldwide for its exceptional length, strength, and softness',
    extraLongStaple: 'Extra-Long Staple',
    extraLongStapleDesc: 'Fibers measuring 1.5-2 inches create unmatched smoothness and durability',
    superiorStrength: 'Superior Strength',
    superiorStrengthDesc: 'Stronger fibers mean fabrics that last longer and resist pilling',
    naturalLuster: 'Natural Luster',
    naturalLusterDesc: 'Unique sheen and softness that improves with every wash',
    giftFromNile: 'A Gift from the Nile',
    giftFromNileDesc1: 'The rich alluvial soil of the Nile Delta, combined with Egypt\'s unique climate, creates the perfect conditions for growing Gossypium barbadense—the world\'s finest cotton variety.',
    giftFromNileDesc2: 'Since ancient times, Egyptian textiles have been prized across civilizations. Pharaohs wrapped their mummies in fine linen, and today, the world\'s luxury brands seek Egyptian cotton for its unmatched quality.',
    giftFromNileDesc3: 'When you choose Egyptian textiles, you\'re choosing a legacy of excellence that spans millennia.',
    meetOurManufacturers: 'Meet Our Manufacturers',
    yearsOfHeritage: 'Years of Heritage',
    fiberLength: 'Fiber Length',
    naturalPure: 'Natural & Pure',
    globalQuality: 'Global Quality',

    // Search Modal
    searchModalTitle: 'What would you like to find?',
    searchModalPlaceholder: 'Search manufacturers, products, categories...',
    recentSearches: 'Recent Searches',
    popularSearches: 'Popular Searches',
    quickLinks: 'Quick Links',
    clearSearch: 'Clear',
    noRecentSearches: 'No recent searches',

    // Industry Categories (Additional)
    browseByIndustry: 'Browse by Industry',
    viewAllCategories: 'View All Categories',

    // Common UI
    language: 'Language',
    theme: 'Theme',
    light: 'Light',
    dark: 'Dark',

    // Product Catalog
    searchProductsPlaceholder: 'Search products by name, category, or specifications...',
    browseProductsDesc: 'Browse our comprehensive database of industrial products and equipment',
    productCatalogTitle: 'Product Catalog',
    productCatalogCount: 'Products',

    // Manufacturer Directory Specific
    searchManufacturersPlaceholder: 'Search manufacturers by name, products, or specialization...',

    // Help Center
    supportAvailable: '24/7 Support',
    helpCenterDesc: 'Find answers to common questions and get the support you need',
    searchForHelp: 'Search for help...',
    faqTitle: 'Frequently Asked Questions',
    faqHowToFind: 'How do I find manufacturers on the platform?',
    faqHowToFindAnswer: 'Use our search feature to browse manufacturers by category, location, or specialization. Filter results based on certifications and ratings.',
    faqVerified: 'Are all manufacturers verified?',
    faqVerifiedAnswer: 'Yes, every manufacturer undergoes our rigorous verification process including business registration, certifications, and facility inspections.',
    faqRequestQuote: 'How do I request a quote?',
    faqRequestQuoteAnswer: 'Visit a manufacturer\'s profile and click "Send Inquiry". Provide your requirements and the manufacturer will respond directly.',
    faqPayment: 'What payment methods are accepted?',
    faqPaymentAnswer: 'Payment terms are negotiated directly between you and the manufacturer. We recommend using secure payment methods.',
    stillNeedHelp: 'Still Need Help?',
    contactSupportTeam: 'Contact our support team',
    emailSupport: 'Email Support',
    phoneSupport: 'Phone Support',

    // Sourcing Guide
    sourcingGuideTitle: 'Sourcing Guide',
    sourcingGuideSubtitle: 'Your complete roadmap to finding and working with the perfect manufacturing partners',
    comprehensiveGuide: 'Comprehensive Guide',
    theSourcingProcess: 'The Sourcing Process',
    defineRequirements: 'Define Your Requirements',
    defineRequirementsDesc: 'Start by clearly outlining your product specifications, quality standards, MOQ, budget range, and delivery timeline. The more detailed your requirements, the better matches you\'ll find.',
    searchFilter: 'Search & Filter',
    searchFilterDesc: 'Use our powerful search tools and advanced filters to narrow down manufacturers by category, location, certifications, production capacity, and specializations.',
    verifyCompare: 'Verify & Compare',
    verifyCompareDesc: 'Review manufacturer profiles, verify certifications, check ratings and reviews, compare capabilities, and assess their track record with previous buyers.',
    requestQuotes: 'Request Quotes',
    requestQuotesDesc: 'Contact multiple manufacturers through our platform, request detailed quotes, negotiate terms, and ask for samples to evaluate quality before making decisions.',
    bestPractices: 'Best Practices',
    verifyCredentials: 'Verify Credentials',
    verifyCredentialsDesc: 'Always check business licenses and certifications',
    reviewSamples: 'Review Samples',
    reviewSamplesDesc: 'Request product samples before placing bulk orders',
    clearCommunication: 'Clear Communication',
    clearCommunicationDesc: 'Maintain documented and transparent communication',
    compareOptions: 'Compare Options',
    compareOptionsDesc: 'Get quotes from multiple manufacturers',
    writtenAgreements: 'Written Agreements',
    writtenAgreementsDesc: 'Always formalize agreements in writing',
    setTimelines: 'Set Timelines',
    setTimelinesDesc: 'Establish clear deadlines and milestones',
    readyToStartSourcing: 'Ready to Start Sourcing?',
    browseMfgDirectory: 'Browse our verified manufacturer directory and connect with trusted suppliers',

    // Quality Standards
    qualityStandardsTitle: 'Quality Standards',
    qualityStandardsSubtitle: 'We maintain rigorous quality standards to ensure all manufacturers meet international requirements',
    certifiedStandards: 'Certified Standards',
    requiredCertifications: 'Required Certifications',
    iso9001: 'ISO 9001:2015',
    iso9001Desc: 'Quality Management Systems',
    iso14001: 'ISO 14001',
    iso14001Desc: 'Environmental Management',
    oekoTex: 'OEKO-TEX Standard 100',
    oekoTexDesc: 'Textile Product Safety',
    gots: 'GOTS',
    gotsDesc: 'Global Organic Textile Standard',
    bci: 'BCI',
    bciDesc: 'Better Cotton Initiative',
    wrap: 'WRAP',
    wrapDesc: 'Worldwide Responsible Production',
    ourQualityProcess: 'Our Quality Control Process',
    initialVerification: 'Initial Verification',
    initialVerificationDesc: 'Document review and business registration check',
    facilityInspection: 'Facility Inspection',
    facilityInspectionDesc: 'On-site assessment of production capabilities',
    sampleTesting: 'Sample Testing',
    sampleTestingDesc: 'Quality evaluation of product samples',
    ongoingMonitoring: 'Ongoing Monitoring',
    ongoingMonitoringDesc: 'Continuous performance tracking and re-certification',
    committedToExcellence: 'Committed to Excellence',
    committedToExcellenceDesc: 'Every manufacturer on our platform undergoes thorough verification and continuous monitoring to ensure the highest quality standards are maintained throughout your partnership.',

    // Verification Process
    verificationProcessTitle: 'Verification Process',
    verificationProcessSubtitle: 'Our comprehensive 6-step verification ensures you connect with credible and capable manufacturers',
    rigorousVerification: 'Rigorous Verification',
    businessRegistration: 'Business Registration Verification',
    businessRegistrationDesc: 'We verify official business registration documents, tax certificates, and legal standing to ensure legitimacy.',
    certificationValidation: 'Certification Validation',
    certificationValidationDesc: 'All quality certifications, industry credentials, and compliance documents are thoroughly checked and validated.',
    facilityInspectionTitle: 'Facility Inspection',
    facilityInspectionDesc2: 'On-site visits to assess production capabilities, quality control systems, and working conditions.',
    capabilityAssessment: 'Capability Assessment',
    capabilityAssessmentDesc: 'Evaluation of production capacity, technical capabilities, equipment, and manufacturing processes.',
    performanceMonitoring: 'Performance Monitoring',
    performanceMonitoringDesc: 'Continuous tracking of manufacturer performance, buyer feedback, and quality metrics.',
    periodicReverification: 'Periodic Re-verification',
    periodicReverificationDesc: 'Regular reassessment and renewal of verification status to maintain quality standards.',
    verifiedBadge: 'Verified Badge',
    verifiedBadgeDesc: 'Manufacturers who successfully complete our verification process receive a verified badge, giving you confidence in their credibility and capabilities.',

    // Blog
    blogTitle: 'Blog',
    blogSubtitle: 'Insights, news, and updates from the world of textile sourcing',
    industryInsights: 'Industry Insights',
    sourcingTips: 'Sourcing Tips',
    qualityAssuranceCategory: 'Quality Assurance',
    readMore: 'Read More',
    blogPost1Title: 'The Future of Egyptian Textile Manufacturing',
    blogPost1Excerpt: 'Exploring trends and innovations shaping Egypt\'s textile industry...',
    blogPost2Title: 'How to Choose the Right Textile Manufacturer',
    blogPost2Excerpt: 'A comprehensive guide to evaluating and selecting manufacturing partners...',
    blogPost3Title: 'Quality Standards in Textile Production',
    blogPost3Excerpt: 'Understanding international quality certifications and their importance...',

    // Privacy Policy
    privacyPolicyTitle: 'Privacy Policy',
    lastUpdated: 'Last updated',
    informationWeCollect: '1. Information We Collect',
    informationWeCollectDesc: 'We collect information you provide directly to us, including name, email address, company information, and any other information you choose to provide.',
    howWeUseInfo: '2. How We Use Your Information',
    howWeUseInfoDesc: 'We use the information we collect to:',
    howWeUseInfo1: 'Provide, maintain, and improve our services',
    howWeUseInfo2: 'Process and complete transactions',
    howWeUseInfo3: 'Send you technical notices and support messages',
    howWeUseInfo4: 'Respond to your comments and questions',
    howWeUseInfo5: 'Monitor and analyze trends, usage, and activities',
    informationSharing: '3. Information Sharing',
    informationSharingDesc: 'We do not share your personal information with third parties except as described in this policy or with your consent.',
    dataSecurity: '4. Data Security',
    dataSecurityDesc: 'We take reasonable measures to help protect your personal information from loss, theft, misuse, unauthorized access, disclosure, alteration, and destruction.',
    yourRights: '5. Your Rights',
    yourRightsDesc: 'You have the right to access, update, or delete your personal information at any time. Contact us for assistance.',
    contactUsPolicy: '6. Contact Us',
    contactUsPolicyDesc: 'If you have questions about this Privacy Policy, please contact us at',

    // Terms of Service
    termsOfServiceTitle: 'Terms of Service',
    acceptanceOfTerms: '1. Acceptance of Terms',
    acceptanceOfTermsDesc: 'By accessing and using EgypTex Gateway, you accept and agree to be bound by the terms and provision of this agreement.',
    useOfService: '2. Use of Service',
    useOfServiceDesc: 'You agree to use the service only for lawful purposes and in accordance with these Terms. You agree not to use the service:',
    useOfService1: 'In any way that violates applicable laws or regulations',
    useOfService2: 'To transmit any unlawful, harmful, or objectionable content',
    useOfService3: 'To impersonate or attempt to impersonate another person or entity',
    useOfService4: 'To engage in any conduct that restricts anyone\'s use of the service',
    userAccounts: '3. User Accounts',
    userAccountsDesc: 'When you create an account, you must provide accurate and complete information. You are responsible for maintaining the confidentiality of your account credentials.',
    intellectualProperty: '4. Intellectual Property',
    intellectualPropertyDesc: 'The service and its original content, features, and functionality are owned by EgypTex Gateway and are protected by international copyright, trademark, and other intellectual property laws.',
    limitationOfLiability: '5. Limitation of Liability',
    limitationOfLiabilityDesc: 'In no event shall EgypTex Gateway be liable for any indirect, incidental, special, consequential, or punitive damages resulting from your use of the service.',
    contactInfoLegal: '6. Contact Information',
    contactInfoLegalDesc: 'For questions about these Terms, please contact us at',

    // Cookie Policy
    cookiePolicyTitle: 'Cookie Policy',
    whatAreCookies: 'What Are Cookies',
    whatAreCookiesDesc: 'Cookies are small text files that are placed on your device when you visit a website. They are widely used to make websites work more efficiently and provide information to website owners.',
    howWeUseCookies: 'How We Use Cookies',
    howWeUseCookiesDesc: 'We use cookies for the following purposes:',
    essentialCookies: 'Essential Cookies:',
    essentialCookiesDesc: 'Required for the website to function properly',
    analyticsCookies: 'Analytics Cookies:',
    analyticsCookiesDesc: 'Help us understand how visitors interact with our website',
    preferenceCookies: 'Preference Cookies:',
    preferenceCookiesDesc: 'Remember your settings and preferences',
    marketingCookies: 'Marketing Cookies:',
    marketingCookiesDesc: 'Track visitors across websites to display relevant advertisements',
    managingCookies: 'Managing Cookies',
    managingCookiesDesc: 'Most web browsers allow you to control cookies through their settings. However, if you limit the ability of websites to set cookies, you may impact your overall user experience.',
    thirdPartyCookies: 'Third-Party Cookies',
    thirdPartyCookiesDesc: 'We may use third-party service providers to monitor and analyze the use of our service. These third parties have their own privacy policies addressing how they use such information.',

    // GDPR Compliance
    gdprComplianceTitle: 'GDPR Compliance',
    gdprComplianceSubtitle: 'Committed to protecting your privacy and ensuring compliance with GDPR',
    gdprCompliantBadge: 'GDPR Compliant',
    yourRightsUnderGDPR: 'Your Rights Under GDPR',
    rightToAccess: 'Right to Access',
    rightToAccessDesc: 'Request copies of your personal data',
    rightToRectification: 'Right to Rectification',
    rightToRectificationDesc: 'Request correction of inaccurate or incomplete data',
    rightToErasure: 'Right to Erasure',
    rightToErasureDesc: 'Request deletion of your personal data',
    rightToDataPortability: 'Right to Data Portability',
    rightToDataPortabilityDesc: 'Request transfer of your data to another organization',
    dataProtectionMeasures: 'Data Protection Measures',
    dataProtection1: 'Encryption of data in transit and at rest',
    dataProtection2: 'Regular security audits and assessments',
    dataProtection3: 'Staff training on data protection',
    dataProtection4: 'Strict access controls and authentication',
    dataProtection5: 'Data breach notification procedures',
    contactDPO: 'Contact Our Data Protection Officer',
    contactDPODesc: 'For any GDPR-related inquiries or to exercise your rights, please contact our DPO:',

    // Blog Management
    blogManagement: 'Blog Management',
    blogManagementDesc: 'Create and manage your blog posts',
    createNewPost: 'Create New Post',
    editPost: 'Edit Post',
    deletePost: 'Delete Post',
    publishPost: 'Publish Post',
    draftPost: 'Save as Draft',
    postTitle: 'Post Title',
    postContent: 'Post Content',
    postCategory: 'Category',
    postStatus: 'Status',
    published: 'Published',
    draft: 'Draft',
    scheduled: 'Scheduled',
    postDate: 'Post Date',
    author: 'Author',
    views: 'Views',
    comments: 'Comments',
    editBlogPost: 'Edit Blog Post',
    deleteBlogPost: 'Delete Blog Post',
    noBlogPostsFound: 'No blog posts found',
    createFirstPost: 'Create your first blog post to get started',
    postTitlePlaceholder: 'Enter post title...',
    postContentPlaceholder: 'Write your blog post content here...',
    selectCategory: 'Select a category',
    featuredImage: 'Featured Image',
    uploadImage: 'Upload Image',
    publishDate: 'Publish Date',
    postExcerpt: 'Post Excerpt',
    postExcerptPlaceholder: 'Brief summary of your post...',
    tags: 'Tags',
    tagsPlaceholder: 'Add tags separated by commas',
    postPublished: 'Post published successfully',
    postSaved: 'Post saved as draft',
    postDeleted: 'Post deleted successfully',

    // Manufacturer Onboarding
    manufacturerOnboarding: 'Manufacturer Onboarding',
    sourceDirectlyFromFactories: 'Source directly from Egypt\'s verified factories',
    registerYourFactoryTitle: 'Register Your Factory',
    registerYourFactoryDesc: 'Join Egypt\'s leading B2B textile manufacturing platform. Submit your factory information for verification and start connecting with global buyers.',
    checkingAuthentication: 'Checking authentication...',

    // Onboarding Steps
    companyInfo: 'Company Info',
    factoryDetails: 'Factory Details',
    yourProducts: 'Your Products',
    documents: 'Documents',
    subscription: 'Subscription',

    // Step 1: Company Information
    companyInformation: 'Company Information',
    companyName: 'Company Name',
    companyNamePlaceholder: 'EgypTex Manufacturing Co.',
    businessLicenseNumber: 'Business License Number',
    businessLicenseNumberPlaceholder: '12345678',
    establishedYear: 'Established Year',
    establishedYearPlaceholder: '2010',
    locationGovernorate: 'Location (Governorate)',
    selectLocation: 'Select location',
    cairo: 'Cairo',
    alexandria: 'Alexandria',
    giza: 'Giza',
    tenthOfRamadan: '10th of Ramadan',
    sixthOfOctober: '6th of October',
    borgElArab: 'Borg El Arab',
    other: 'Other',
    fullAddress: 'Full Address',
    fullAddressPlaceholder: 'Street address, city, postal code',
    website: 'Website',
    websitePlaceholder: 'https://yourcompany.com',
    phoneNumber: 'Phone Number',
    phoneNumberPlaceholder: '+20 XXX XXX XXXX',

    // Step 2: Factory Details
    factorySize: 'Factory Size (sq meters)',
    factorySizePlaceholder: '5000',
    numberOfEmployees: 'Number of Employees',
    numberOfEmployeesPlaceholder: '150',
    productionCapacity: 'Production Capacity (per month)',
    productionCapacityPlaceholder: '100,000 meters of fabric',
    mainCategory: 'Main Category',
    selectMainCategory: 'Select main category',
    yarnAndSpinning: 'Yarn & Spinning',
    fabricsAndTextiles: 'Fabrics & Textiles',
    accessoriesAndTrims: 'Accessories & Trims',
    textileMachineryCategory: 'Textile Machinery',
    others: 'Others',

    // Step 3: Products
    productNumber: 'Product #',
    productName: 'Product Name',
    productNamePlaceholder: '100% Egyptian Cotton Fabric',
    productDescription: 'Product Description',
    productDescriptionPlaceholder: 'Detailed description including specifications, materials, uses...',
    minimumOrderQuantity: 'Minimum Order Quantity',
    minimumOrderQuantityPlaceholder: '1000 meters',
    priceRange: 'Price Range (Egyptian Pounds - EGP)',
    priceRangePlaceholder: '$5 - $15 per meter',

    // Step 4: Documents
    documentsVerification: 'Documents & Verification',
    requiredDocuments: 'Required Documents',
    businessLicensePdf: 'Business License (PDF, max 5MB)',
    certificationDocsOptional: 'Certification Documents (Optional, PDF)',
    productImagesDocs: 'Product Images (JPG/PNG, max 2MB each)',
    businessLicense: 'Business License',
    clickToUpload: 'Click to upload or drag and drop',
    pdfMax5mb: 'PDF (max 5MB)',
    fileUploaded: 'File uploaded',
    certificationDocuments: 'Certification Documents (Optional)',
    uploadCertificates: 'Upload your certificates (ISO, OEKO-TEX, etc.)',
    pdfMax5mbMultiple: 'PDF (max 5MB each, multiple files allowed)',
    filesSelected: 'file(s) selected',
    whatHappensNext: 'What happens next?',
    verificationStep1: 'Our verification team reviews your submission (2-3 business days)',
    verificationStep2: 'We\'ll contact you if additional information is needed',
    verificationStep3: 'Once approved, your factory profile goes live on the platform',
    verificationStep4: 'Start receiving inquiries from global buyers',

    // Step 5: Subscription
    chooseYourPlan: 'Choose Your Plan',
    selectPlanDesc: 'Select the plan that best fits your business needs',
    monthly: 'Monthly',
    yearly: 'Yearly',
    saveTwoMonths: 'Save 2 months',
    freePlan: 'Free Plan',
    freePlanArabic: 'الخطة المجانية',
    free: 'Free',
    freeArabic: 'مجاني',
    basicAccountCreation: 'Basic account creation',
    simpleCompanyProfile: 'Simple company profile',
    upTo3Products: 'Up to 3 products',
    publicSearchResults: 'Public search results',
    threeInquiriesPerMonth: '3 inquiries/month',
    emailSupportPlan: 'Email support',
    standardPlan: 'Standard Plan',
    standardPlanArabic: 'الخطة المدفوعة',
    popular: 'POPULAR',
    egpMonthly: 'EGP 1,000',
    egpMonthlyArabic: '1000 جنيه / شهريًا',
    egpYearly: 'EGP 10,000',
    egpYearlyArabic: '10,000 جنيه / سنويًا',
    allFreeFeatures: 'All Free features',
    fullFactoryProfile: 'Full factory profile',
    upTo15Products: 'Up to 15 products',
    unlimitedInquiries: 'Unlimited inquiries',
    directMessaging: 'Direct messaging',
    higherVisibility: 'Higher visibility',
    applyToRfqs: 'Apply to RFQs',
    prioritySupport: 'Priority support',
    proPlan: 'Pro Plan',
    proPlanArabic: 'الخطة الاحترافية',
    egpProMonthly: 'EGP 2,000',
    egpProMonthlyArabic: '2000 جنيه / شهريًا',
    egpProYearly: 'EGP 20,000',
    egpProYearlyArabic: '20,000 جنيه / سنويًا',
    allStandardFeatures: 'All Standard features',
    unlimitedProducts: 'Unlimited products',
    topPrioritySearch: 'Top priority search',
    verifiedSupplierBadge: 'Verified Supplier badge',
    homepageFeatured: 'Homepage featured',
    performanceAnalyticsPlan: 'Performance analytics',
    dedicatedSupport: 'Dedicated support',
    marketingCampaigns: 'Marketing campaigns',
    importantNotes: 'Important Notes',
    startFreeUpgradeAnytime: 'You can start with the Free plan and upgrade anytime',
    yearlySavings: 'Yearly plans save you 2 months (Standard: EGP 2,000 | Pro: EGP 4,000)',
    switchBillingAnytime: 'Switch between monthly and yearly billing anytime',
    allPlansIncludeVerification: 'All plans include our verification process',
    paymentAfterApproval: 'Payment will be processed after approval',
    yourSelection: 'Your Selection',
    plan: 'Plan',
    billing: 'Billing',
    clickSubmitToComplete: 'Click "Submit for Review" below to complete your registration',

    // Navigation Buttons
    previous: 'Previous',
    nextStep: 'Next Step',
    submitForReview: 'Submit for Review',
    submitting: 'Submitting...',
    backToHomepage: 'Back to Homepage',

    // Required indicator
    required: '*',
  },

  ar: {
    // Navigation
    home: 'الرئيسية',
    manufacturers: 'المصنعون',
    products: 'المنتجات',
    more: 'المزيد',
    inquiries: 'الاستفسارات',
    dashboard: 'لوحة التحكم',
    startSourcing: 'ابدأ التوريد',

    // Homepage
    heroTagline: 'التوريد مباشرة من مصانع مصر المعتمدة',
    heroTitle: 'التوريد مباشرة من',
    heroTitleHighlight: 'مصانع مصر المعتمدة',
    heroSubtitle: 'من الكتان القديم إلى التميز الحديث',
    heroSubtitle2: '3000+ عام من إتقان صناعة النسيج',
    searchPlaceholder: 'ابحث عن المصنعين أو المنتجات أو الفئات...',
    searchButton: 'بحث',
    exploreCategories: 'استكشف الفئات',

    // Hero Era Badges
    ancientEgypt: 'مصر القديمة - 3000 قبل الميلاد',
    ancientEgyptDesc: 'رواد نسج الكتان الفاخر',
    traditionalCraftsmanship: 'الحرفية التقليدية',
    traditionalCraftsmanshipDesc: 'أجيال من إتقان النسيج',
    modernExcellence: 'التميز الحديث',
    modernExcellenceDesc: 'تصنيع عالمي المستوى',
    worldClassManufacturing: 'تصنيع عالمي المستوى',

    // Egyptian Textile Categories
    yarnSpinning: 'غزل وخيوط',
    yarnSpinningDesc: 'غزل قطن مصري فاخر وخدمات غزل',
    fabricsTextiles: 'أقمشة ومنسوجات',
    fabricsTextilesDesc: 'أقمشة تقنية ومنسوجات فاخرة',
    accessoriesTrims: 'إكسسوارات ومكملات',
    accessoriesTrimsDesc: 'إكسسوارات نسيجية، أزرار، سحابات ومكملات',
    machineryEquipment: 'ماكينات ومعدات',
    machineryEquipmentDesc: 'معدات وماكينات تصنيع المنسوجات',
    textileMachinery: 'ماكينات نسيج',
    textileMachineryDesc: 'ماكينات غزل، أنوال نسيج، معدات صباغة، وآلات إنتاج المنسوجات',

    // Visitor Actions
    whatWouldYouLikeToDo: 'ماذا تريد أن تفعل؟',
    browseManufacturersAction: 'تصفح المصنعين',
    browseProductsAction: 'تصفح المنتجات',
    sendInquiryAction: 'إرسال استفسار',
    orSearchDirectly: 'أو ابحث مباشرة:',

    // Featured Manufacturers
    featuredManufacturers: 'المصنعون المميزون المعتمدون',
    featuredManufacturersDesc: 'تواصل مع المصنعين ذوي التصنيف العالي الذين أظهروا التميز في الجودة والموثوقية وخدمة العملاء.',
    verified: 'معتمد',
    productsCount: 'منتجات',
    responseRate: 'معدل الاستجابة',
    viewProfile: 'عرض الملف الشخصي',
    viewAllManufacturers: 'عرض جميع المصنعين',

    // Categories
    industryCategories: 'فئات الصناعة',
    categoriesDesc: 'استكشف مجموعتنا الشاملة من فئات المنسوجات والتصنيع. اعثر على ما تحتاجه بالضبط من خلال الفلترة المتخصصة.',
    totalCategories: 'إجمالي الفئات',
    totalProductsInCategories: 'إجمالي المنتجات',
    trending: 'الرائجة',
    allCategories: 'جميع الفئات',
    searchCategories: 'البحث في الفئات...',
    exploreCategory: 'استكشف الفئة',
    subcategories: 'الفئات الفرعية',

    // Manufacturer Directory
    manufacturerDirectory: 'دليل المصنعين',
    manufacturerDirectoryDesc: 'تواصل مع مصنعي المنسوجات المصريين المعتمدين والموردين. اعثر على الشريك المثالي لاحتياجات عملك.',
    totalManufacturers: 'إجمالي المصنعين',
    verifiedCompanies: 'الشركات المعتمدة',
    activeProducts: 'المنتجات النشطة',
    monthlyInquiries: 'الاستفسارات الشهرية',
    searchManufacturers: 'البحث عن المصنعين...',
    allLocations: 'جميع المواقع',
    showing: 'عرض',
    manufacturer: 'مصنع',
    manufacturers_plural: 'مصنعين',
    location: 'الموقع',
    since: 'منذ',
    staff: 'الموظفين',
    rating: 'التقييم',
    certifications: 'الشهادات',
    noManufacturersFound: 'لم يتم العثور على مصنعين',
    tryAdjustingFilters: 'حاول تعديل معايير البحث أو الفلاتر',
    areYouManufacturer: 'هل أنت مصنع؟',
    registerFactoryDesc: 'سجل مصنعك لعرض المنتجات والتواصل مع المشترين العالميين',
    registerYourFactory: 'سجل مصنعك',

    // Product Catalog
    productCatalog: 'كتالوج المنتجات',
    productCatalogDesc: 'تصفح مجموعتنا الواسعة من المنتجات النسيجية المعتمدة من المصنعين الموثوقين.',
    filters: 'الفلاتر',
    sortBy: 'ترتيب حسب',
    relevance: 'الملاءمة',
    priceLowToHigh: 'السعر: من الأقل إلى الأعلى',
    priceHighToLow: 'السعر: من الأعلى إلى الأقل',
    newest: 'الأحدث',
    searchProducts: 'البحث عن المنتجات...',
    minOrder: 'الحد الأدنى للطلب',
    sendInquiry: 'إرسال استفسار',

    // Sign In
    signIn: 'تسجيل الدخول',
    welcomeBack: 'مرحباً بعودتك',
    signInDesc: 'قم بتسجيل الدخول للوصول إلى لوحة التحكم الخاصة بك وإدارة عمليات عملك.',
    email: 'البريد الإلكتروني',
    password: 'كلمة المرور',
    selectRole: 'اختر دورك',
    owner: 'المالك',
    admin: 'المسؤول',
    ownerDesc: 'وصول كامل لجميع الميزات',
    adminDesc: 'إدارة العمليات',

    // Common
    category: 'الفئة',
    description: 'الوصف',
    noResultsFound: 'لم يتم العثور على نتائج',
    loading: 'جاري التحميل...',
    error: 'خطأ',
    success: 'نجح',
    cancel: 'إلغاء',
    save: 'حفظ',
    delete: 'حذف',
    edit: 'تعديل',
    view: 'عرض',

    // Vendor Dashboard
    vendorDashboard: 'لوحة تحكم البائع',
    dashboardSubtitle: 'إدارة ملفك الشخصي ومنتجاتك واستفساراتك من موقع مركزي واحد',
    overview: 'نظرة عامة',
    analytics: 'التحليلات',
    profile: 'الملف الشخصي',
    settings: 'الإعدادات',
    navigation: 'التنقل',
    quickActions: 'إجراءات سريعة',
    needHelp: 'هل تحتاج مساعدة؟',
    helpDescription: 'تحقق من الوثائق أو اتصل بالدعم',
    viewDocs: 'عرض المستندات',

    // Dashboard Stats
    totalProducts: 'إجمالي المنتجات',
    activeInquiries: 'الاستفسارات النشطة',
    profileViews: 'مشاهدات الملف الشخصي',
    profileCompletion: 'اكتمال الملف الشخصي',
    completeProfile: 'أكمل الملف الشخصي',
    completeProfileDesc: 'أكمل ملفك الشخصي لزيادة الظهور',
    missingInformation: 'المعلومات المفقودة:',

    // Performance & Notifications
    performanceAnalytics: 'تحليلات الأداء',
    notifications: 'الإشعارات',
    all: 'الكل',
    approvals: 'الموافقات',
    system: 'النظام',
    messages: 'الرسائل',
    noNotificationsFound: 'لم يتم العثور على إشعارات',
    showLess: 'عرض أقل',
    viewAll: 'عرض الكل',

    // Inquiries Table
    recentInquiries: 'الاستفسارات الأخيرة',
    buyer: 'المشتري',
    product: 'المنتج',
    quantity: 'الكمية',
    date: 'التاريخ',
    priority: 'الأولوية',
    status: 'الحالة',
    action: 'الإجراء',
    viewDetails: 'عرض التفاصيل',
    high: 'عالية',
    medium: 'متوسطة',
    low: 'منخفضة',
    pending: 'قيد الانتظار',
    responded: 'تم الرد',
    closed: 'مغلق',

    // Product Management
    productCatalogManager: 'كتالوج المنتجات',
    addProduct: 'إضافة منتج',
    allStatus: 'جميع الحالات',
    active: 'نشط',
    inactive: 'غير نشط',
    stock: 'المخزون',
    price: 'السعر',

    // Quick Actions
    addNewProduct: 'إضافة منتج جديد',
    addNewProductDesc: 'أضف منتج جديد إلى الكتالوج الخاص بك',
    manageInquiries: 'إدارة الاستفسارات',
    manageInquiriesDesc: 'عرض والرد على استفسارات المشترين',
    updateProfile: 'تحديث الملف الشخصي',
    updateProfileDesc: 'أكمل ملف شركتك الشخصي',

    // CTA Section
    ctaTitle: 'هل أنت مستعد لتحويل استراتيجية التوريد الخاصة بك؟',
    ctaSubtitle: 'انضم إلى آلاف المحترفين في مجال المشتريات الذين يثقون في EgypTex Gateway للحصول على اتصالات موثوقة ومبنية على البيانات مع المصنعين.',
    browseManufacturers: 'تصفح المصنعين',
    exploreProducts: 'استكشف المنتجات',
    trustedBy: 'موثوق به من قبل الشركات الرائدة في جميع أنحاء العالم',
    fortune500: 'شركات فورتشن 500',
    smeManufacturers: 'المصنعين الصغار والمتوسطين',
    internationalTraders: 'التجار الدوليين',

    // Footer
    connectingManufacturers: 'ربط المصنعين المعتمدين مع المشترين العالميين من خلال الدقة القائمة على البيانات.',
    platform: 'المنصة',
    resources: 'الموارد',
    company: 'الشركة',
    legal: 'قانوني',
    sourcingGuide: 'دليل التوريد',
    qualityStandards: 'معايير الجودة',
    verificationProcess: 'عملية التحقق',
    helpCenter: 'مركز المساعدة',
    aboutUs: 'من نحن',
    contact: 'اتصل بنا',
    blog: 'المدونة',
    privacyPolicy: 'سياسة الخصوصية',
    termsOfService: 'شروط الخدمة',
    cookiePolicy: 'سياسة ملفات تعريف الارتباط',
    gdprCompliance: 'التوافق مع GDPR',
    allRightsReserved: 'جميع الحقوق محفوظة',
    isoCertified: 'معتمد ISO 9001',
    gdprCompliant: 'متوافق مع GDPR',

    // Success Stories
    successStories: 'قصص النجاح',
    successStoriesDesc: 'نتائج حقيقية من الشركات التي حولت استراتيجية التوريد الخاصة بها مع EgypTex Gateway.',
    challenge: 'التحدي',
    solution: 'الحل',
    results: 'النتائج',

    // Trust Indicators
    trustSecurity: 'الثقة والأمان',
    trustSecurityDesc: 'نجاحك في التوريد يُبنى على التزامنا بالشفافية والأمان وضمان الجودة.',
    verifiedManufacturers: 'مصنعون معتمدون',
    verifiedManufacturersDesc: 'يخضع كل مصنع لعملية تحقق صارمة تشمل تسجيل الأعمال والشهادات وتقييمات القدرات.',
    securePlatform: 'منصة آمنة',
    securePlatformDesc: 'أمان على مستوى المؤسسات مع تشفير SSL والامتثال لـ GDPR وبروتوكولات آمنة للتعامل مع البيانات.',
    qualityAssurance: 'ضمان الجودة',
    qualityAssuranceDesc: 'منصة معتمدة ISO 9001 مع مراقبة مستمرة وعمليات مراقبة الجودة.',
    globalStandards: 'المعايير العالمية',
    globalStandardsDesc: 'الامتثال للوائح التجارة الدولية ومعايير الجودة الخاصة بالصناعة.',
    platformCertifications: 'شهادات المنصة والامتثال',
    platformIso9001: 'ISO 9001:2015',
    platformSslSecured: 'مؤمن بـ SSL',
    platformSoc2: 'SOC 2 Type II',

    // Platform Metrics
    activeManufacturers: 'المصنعين النشطين',
    productListings: 'قوائم المنتجات',
    successfulConnections: 'الاتصالات الناجحة',
    averageResponseTime: 'متوسط ​​وقت الاستجابة',

    // Heritage Timeline
    ourHeritage: 'تراثنا',
    legacyWovenThroughTime: 'إرث منسوج عبر الزمن',
    heritageTimelineDesc: 'من الأنوال القديمة إلى المصانع الحديثة، يمتد تقليد النسيج المصري لآلاف السنين',
    ancientEgyptEra: 'مصر القديمة',
    ancientEgyptYear: '3000 قبل الميلاد',
    birthOfFineTextiles: 'ولادة المنسوجات الفاخرة',
    birthOfFineTextilesDesc: 'ابتكر الحرفيون المصريون تقنيات نسج الكتان التي أنتجت أقمشة رائعة لدرجة أنها كانت ثمينة في الحضارات القديمة. ارتدى الفراعنة الكتان كرمز للنقاء والنور.',
    traditionalCraftsmanshipEra: 'الحرفية التقليدية',
    traditionalCraftsmanshipYear: '1000 - 1900 ميلادي',
    generationsOfMastery: 'أجيال من الإتقان',
    generationsOfMasteryDesc: 'عبر القرون، صقل الحرفيون المصريون مهاراتهم، ونقلوا التقنيات من جيل إلى جيل. ظل الغزل اليدوي والنسيج فنًا من الدقة والصبر.',
    modernEra: 'العصر الحديث',
    modernEraYear: '1900 - الحاضر',
    globalExcellenceManufacturing: 'التميز العالمي في التصنيع',
    globalExcellenceManufacturingDesc: 'أصبح القطن المصري طويل التيلة أسطوريًا في جميع أنحاء العالم. اليوم، نجمع بين الحرفية القديمة والتكنولوجيا المتطورة لإنتاج منسوجات تلبي أعلى المعايير الدولية.',

    // Egyptian Cotton Story
    theGoldStandard: 'المعيار الذهبي',
    egyptianLongStapleCotton: 'القطن المصري طويل التيلة',
    egyptianCottonDesc: 'يُزرع في دلتا النيل الخصبة، قطننا مشهور عالميًا بطوله الاستثنائي وقوته ونعومته',
    extraLongStaple: 'تيلة طويلة جدًا',
    extraLongStapleDesc: 'ألياف يبلغ طولها 1.5-2 بوصة تخلق نعومة ومتانة لا مثيل لها',
    superiorStrength: 'قوة فائقة',
    superiorStrengthDesc: 'ألياف أقوى تعني أقمشة تدوم لفترة أطول وتقاوم التكتل',
    naturalLuster: 'بريق طبيعي',
    naturalLusterDesc: 'لمعان ونعومة فريدة تتحسن مع كل غسلة',
    giftFromNile: 'هدية من النيل',
    giftFromNileDesc1: 'التربة الغرينية الغنية لدلتا النيل، جنبًا إلى جنب مع مناخ مصر الفريد، تخلق الظروف المثالية لزراعة Gossypium barbadense - أفضل أنواع القطن في العالم.',
    giftFromNileDesc2: 'منذ العصور القديمة، كانت المنسوجات المصرية ثمينة عبر الحضارات. لف الفراعنة مومياواتهم بالكتان الفاخر، واليوم، تسعى العلامات التجارية الفاخرة في العالم إلى القطن المصري لجودته التي لا مثيل لها.',
    giftFromNileDesc3: 'عندما تختار المنسوجات المصرية، فإنك تختار إرثًا من التميز يمتد لآلاف السنين.',
    meetOurManufacturers: 'تعرف على مصنعينا',
    yearsOfHeritage: 'سنوات من التراث',
    fiberLength: 'طول الألياف',
    naturalPure: 'طبيعي ونقي',
    globalQuality: 'جودة عالمية',

    // Search Modal
    searchModalTitle: 'ماذا تريد أن تجد؟',
    searchModalPlaceholder: 'البحث عن المصنعين، المنتجات، الفئات...',
    recentSearches: 'عمليات البحث الأخيرة',
    popularSearches: 'عمليات البحث الشائعة',
    quickLinks: 'روابط سريعة',
    clearSearch: 'مسح',
    noRecentSearches: 'لا توجد عمليات بحث حديثة',

    // Industry Categories (Additional)
    browseByIndustry: 'تصفح حسب الصناعة',
    viewAllCategories: 'عرض جميع الفئات',

    // Common UI
    language: 'اللغة',
    theme: 'المظهر',
    light: 'فاتح',
    dark: 'داكن',

    // Product Catalog
    searchProductsPlaceholder: 'البحث عن المنتجات بالاسم أو الفئة أو المواصفات...',
    browseProductsDesc: 'تصفح قاعدة بياناتنا الشاملة للمنتجات والمعدات الصناعية',
    productCatalogTitle: 'كتالوج منتجات',
    productCatalogCount: 'منتجات',

    // Manufacturer Directory Specific
    searchManufacturersPlaceholder: 'البحث عن المصنعين بالاسم أو المنتجات أو التخصص...',

    // Help Center
    supportAvailable: 'الدعم 24/7',
    helpCenterDesc: 'اعثر على إجابات للأسئلة الشائعة واحصل على الدعم الذي تحتاجه',
    searchForHelp: 'البحث عن المساعدة...',
    faqTitle: 'الأسئلة الشائعة',
    faqHowToFind: 'كيف يمكنني العثور على المصنعين على المنصة؟',
    faqHowToFindAnswer: 'استخدم ميزة البحث لدينا لتصفح المصنعين حسب الفئة أو الموقع أو التخصص. قم بتصفية النتائج بناءً على الشهادات والتقييمات.',
    faqVerified: 'هل جميع المصنعين موثقين؟',
    faqVerifiedAnswer: 'نعم، يخضع كل مصنع لعملية التحقق الصارمة التي تشمل تسجيل الأعمال والشهادات وفحوصات المنشآت.',
    faqRequestQuote: 'كيف يمكنني طلب عرض أسعار؟',
    faqRequestQuoteAnswer: 'قم بزيارة الملف الشخصي للمصنع وانقر على "إرسال استفسار". قدم متطلباتك وسيرد المصنع مباشرة.',
    faqPayment: 'ما هي طرق الدفع المقبولة؟',
    faqPaymentAnswer: 'يتم التفاوض على شروط الدفع مباشرة بينك وبين الشركة المصنعة. نوصي باستخدام طرق الدفع الآمنة.',
    stillNeedHelp: 'ما زلت بحاجة إلى مساعدة؟',
    contactSupportTeam: 'اتصل بفريق الدعم لدينا',
    emailSupport: 'دعم البريد الإلكتروني',
    phoneSupport: 'الدعم الهاتفي',

    // Sourcing Guide
    sourcingGuideTitle: 'دليل التوريد',
    sourcingGuideSubtitle: 'خارطة طريقك الكاملة للعثور على شركاء التصنيع المثاليين والعمل معهم',
    comprehensiveGuide: 'دليل شامل',
    theSourcingProcess: 'عملية التوريد',
    defineRequirements: 'حدد متطلباتك',
    defineRequirementsDesc: 'ابدأ بتحديد مواصفات منتجك بوضوح ومعايير الجودة والحد الأدنى للطلب ونطاق الميزانية والجدول الزمني للتسليم. كلما كانت متطلباتك أكثر تفصيلاً، كانت المطابقات أفضل.',
    searchFilter: 'البحث والتصفية',
    searchFilterDesc: 'استخدم أدوات البحث القوية والمرشحات المتقدمة لتضييق نطاق المصنعين حسب الفئة والموقع والشهادات وقدرة الإنتاج والتخصصات.',
    verifyCompare: 'التحقق والمقارنة',
    verifyCompareDesc: 'راجع ملفات تعريف المصنعين، تحقق من الشهادات، تحقق من التقييمات والمراجعات، قارن القدرات، وقيم سجلهم مع المشترين السابقين.',
    requestQuotes: 'طلب عروض الأسعار',
    requestQuotesDesc: 'اتصل بعدة مصنعين من خلال منصتنا، اطلب عروض أسعار مفصلة، تفاوض على الشروط، واطلب عينات لتقييم الجودة قبل اتخاذ القرارات.',
    bestPractices: 'أفضل الممارسات',
    verifyCredentials: 'التحقق من الاعتمادات',
    verifyCredentialsDesc: 'تحقق دائماً من تراخيص الأعمال والشهادات',
    reviewSamples: 'مراجعة العينات',
    reviewSamplesDesc: 'اطلب عينات المنتجات قبل تقديم طلبات كبيرة',
    clearCommunication: 'تواصل واضح',
    clearCommunicationDesc: 'حافظ على التواصل الموثق والشفاف',
    compareOptions: 'قارن الخيارات',
    compareOptionsDesc: 'احصل على عروض أسعار من عدة مصنعين',
    writtenAgreements: 'اتفاقيات مكتوبة',
    writtenAgreementsDesc: 'اجعل الاتفاقيات رسمية كتابياً دائماً',
    setTimelines: 'حدد المواعيد النهائية',
    setTimelinesDesc: 'حدد مواعيد نهائية ومعالم واضحة',
    readyToStartSourcing: 'هل أنت مستعد لبدء التوريد؟',
    browseMfgDirectory: 'تصفح دليل المصنعين المعتمدين لدينا وتواصل مع موردين موثوقين',

    // Quality Standards
    qualityStandardsTitle: 'معايير الجودة',
    qualityStandardsSubtitle: 'نحافظ على معايير جودة صارمة لضمان استيفاء جميع المصنعين للمتطلبات الدولية',
    certifiedStandards: 'معايير معتمدة',
    requiredCertifications: 'الشهادات المطلوبة',
    iso9001: 'ISO 9001:2015',
    iso9001Desc: 'أنظمة إدارة الجودة',
    iso14001: 'ISO 14001',
    iso14001Desc: 'الإدارة البيئية',
    oekoTex: 'OEKO-TEX Standard 100',
    oekoTexDesc: 'سلامة المنتجات النسيجية',
    gots: 'GOTS',
    gotsDesc: 'المعيار العالمي للنسيج العضوي',
    bci: 'BCI',
    bciDesc: 'مبادرة القطن الأفضل',
    wrap: 'WRAP',
    wrapDesc: 'الإنتاج المسؤول في جميع أنحاء العالم',
    ourQualityProcess: 'عملية مراقبة الجودة لدينا',
    initialVerification: 'التحقق الأولي',
    initialVerificationDesc: 'مراجعة المستندات والتحقق من تسجيل الأعمال',
    facilityInspection: 'فحص المنشأة',
    facilityInspectionDesc: 'تقييم في الموقع لقدرات الإنتاج',
    sampleTesting: 'اختبار العينات',
    sampleTestingDesc: 'تقييم جودة عينات المنتجات',
    ongoingMonitoring: 'المراقبة المستمرة',
    ongoingMonitoringDesc: 'تتبع الأداء المستمر وإعادة الاعتماد',
    committedToExcellence: 'ملتزمون بالتميز',
    committedToExcellenceDesc: 'يخضع كل مصنع على منصتنا للتحقق الشامل والمراقبة المستمرة لضمان الحفاظ على أعلى معايير الجودة طوال شراكتك.',

    // Verification Process
    verificationProcessTitle: 'عملية التحقق',
    verificationProcessSubtitle: 'تضمن عملية التحقق الشاملة المكونة من 6 خطوات اتصالك بمصنعين موثوقين وقادرين',
    rigorousVerification: 'تحقق صارم',
    businessRegistration: 'التحقق من تسجيل الأعمال',
    businessRegistrationDesc: 'نتحقق من مستندات تسجيل الأعمال الرسمية وشهادات الضرائب والوضع القانوني لضمان الشرعية.',
    certificationValidation: 'التحقق من الشهادات',
    certificationValidationDesc: 'يتم فحص والتحقق من جميع شهادات الجودة وأوراق اعتماد الصناعة ومستندات الامتثال بدقة.',
    facilityInspectionTitle: 'فحص المنشأة',
    facilityInspectionDesc2: 'زيارات في الموقع لتقييم قدرات الإنتاج وأنظمة مراقبة الجودة وظروف العمل.',
    capabilityAssessment: 'تقييم القدرات',
    capabilityAssessmentDesc: 'تقييم القدرة الإنتاجية والقدرات التقنية والمعدات وعمليات التصنيع.',
    performanceMonitoring: 'مراقبة الأداء',
    performanceMonitoringDesc: 'تتبع مستمر لأداء المصنع وملاحظات المشترين ومقاييس الجودة.',
    periodicReverification: 'إعادة التحقق الدورية',
    periodicReverificationDesc: 'إعادة التقييم المنتظم وتجديد حالة التحقق للحفاظ على معايير الجودة.',
    verifiedBadge: 'شارة التحقق',
    verifiedBadgeDesc: 'يحصل المصنعون الذين يكملون عملية التحقق بنجاح على شارة التحقق، مما يمنحك الثقة في مصداقيتهم وقدراتهم.',

    // Blog
    blogTitle: 'المدونة',
    blogSubtitle: 'رؤى وأخبار وتحديثات من عالم توريد المنسوجات',
    industryInsights: 'رؤى الصناعة',
    sourcingTips: 'نصائح التوريد',
    qualityAssuranceCategory: 'ضمان الجودة',
    readMore: 'اقرأ المزيد',
    blogPost1Title: 'مستقبل التصنيع النسيجي المصري',
    blogPost1Excerpt: 'استكشاف الاتجاهات والابتكارات التي تشكل صناعة النسيج في مصر...',
    blogPost2Title: 'كيفية اختيار مصنع النسيج المناسب',
    blogPost2Excerpt: 'دليل شامل لتقييم واختيار شركاء التصنيع...',
    blogPost3Title: 'معايير الجودة في إنتاج المنسوجات',
    blogPost3Excerpt: 'فهم شهادات الجودة الدولية وأهميتها...',

    // Privacy Policy
    privacyPolicyTitle: 'سياسة الخصوصية',
    lastUpdated: 'آخر تحديث',
    informationWeCollect: '1. المعلومات التي نجمعها',
    informationWeCollectDesc: 'نجمع المعلومات التي تقدمها لنا مباشرة، بما في ذلك الاسم وعنوان البريد الإلكتروني ومعلومات الشركة وأي معلومات أخرى تختار تقديمها.',
    howWeUseInfo: '2. كيف نستخدم معلوماتك',
    howWeUseInfoDesc: 'نستخدم المعلومات التي نجمعها من أجل:',
    howWeUseInfo1: 'توفير خدماتنا وصيانتها وتحسينها',
    howWeUseInfo2: 'معالجة وإكمال المعاملات',
    howWeUseInfo3: 'إرسال إشعارات فنية ورسائل دعم',
    howWeUseInfo4: 'الرد على تعليقاتك وأسئلتك',
    howWeUseInfo5: 'مراقبة وتحليل الاتجاهات والاستخدام والأنشطة',
    informationSharing: '3. مشاركة المعلومات',
    informationSharingDesc: 'لا نشارك معلوماتك الشخصية مع جهات خارجية إلا كما هو موضح في هذه السياسة أو بموافقتك.',
    dataSecurity: '4. أمن البيانات',
    dataSecurityDesc: 'نتخذ تدابير معقولة للمساعدة في حماية معلوماتك الشخصية من الفقدان أو السرقة أو سوء الاستخدام أو الوصول غير المصرح به أو الكشف أو التغيير أو التدمير.',
    yourRights: '5. حقوقك',
    yourRightsDesc: 'لديك الحق في الوصول إلى معلوماتك الشخصية أو تحديثها أو حذفها في أي وقت. اتصل بنا للحصول على المساعدة.',
    contactUsPolicy: '6. اتصل بنا',
    contactUsPolicyDesc: 'إذا كانت لديك أسئلة حول سياسة الخصوصية هذه، يرجى الاتصال بنا على',

    // Terms of Service
    termsOfServiceTitle: 'شروط الخدمة',
    acceptanceOfTerms: '1. قبول الشروط',
    acceptanceOfTermsDesc: 'من خلال الوصول واستخدام EgypTex Gateway، فإنك تقبل وتوافق على الالتزام بشروط وأحكام هذه الاتفاقية.',
    useOfService: '2. استخدام الخدمة',
    useOfServiceDesc: 'أنت توافق على استخدام الخدمة فقط لأغراض قانونية ووفقاً لهذه الشروط. أنت توافق على عدم استخدام الخدمة:',
    useOfService1: 'بأي طريقة تنتهك القوانين أو اللوائح المعمول بها',
    useOfService2: 'لنقل أي محتوى غير قانوني أو ضار أو مثير للاعتراض',
    useOfService3: 'لانتحال شخصية أو محاولة انتحال شخصية شخص آخر أو كيان',
    useOfService4: 'للمشاركة في أي سلوك يقيد استخدام أي شخص للخدمة',
    userAccounts: '3. حسابات المستخدمين',
    userAccountsDesc: 'عند إنشاء حساب، يجب عليك تقديم معلومات دقيقة وكاملة. أنت مسؤول عن الحفاظ على سرية بيانات اعتماد حسابك.',
    intellectualProperty: '4. الملكية الفكرية',
    intellectualPropertyDesc: 'الخدمة ومحتواها الأصلي وميزاتها ووظائفها مملوكة لـ EgypTex Gateway ومحمية بموجب قوانين حقوق النشر والعلامات التجارية والملكية الفكرية الدولية الأخرى.',
    limitationOfLiability: '5. تحديد المسؤولية',
    limitationOfLiabilityDesc: 'لن تكون EgypTex Gateway مسؤولة بأي حال من الأحوال عن أي أضرار غير مباشرة أو عرضية أو خاصة أو تبعية أو عقابية ناتجة عن استخدامك للخدمة.',
    contactInfoLegal: '6. معلومات الاتصال',
    contactInfoLegalDesc: 'للأسئلة حول هذه الشروط، يرجى الاتصال بنا على',

    // Cookie Policy
    cookiePolicyTitle: 'سياسة ملفات تعريف الارتباط',
    whatAreCookies: 'ما هي ملفات تعريف الارتباط',
    whatAreCookiesDesc: 'ملفات تعريف الارتباط هي ملفات نصية صغيرة يتم وضعها على جهازك عند زيارة موقع ويب. يتم استخدامها على نطاق واسع لجعل مواقع الويب تعمل بشكل أكثر كفاءة وتوفير معلومات لأصحاب المواقع.',
    howWeUseCookies: 'كيف نستخدم ملفات تعريف الارتباط',
    howWeUseCookiesDesc: 'نستخدم ملفات تعريف الارتباط للأغراض التالية:',
    essentialCookies: 'ملفات تعريف الارتباط الأساسية:',
    essentialCookiesDesc: 'مطلوبة لعمل الموقع بشكل صحيح',
    analyticsCookies: 'ملفات تعريف الارتباط التحليلية:',
    analyticsCookiesDesc: 'تساعدنا على فهم كيفية تفاعل الزوار مع موقعنا',
    preferenceCookies: 'ملفات تعريف الارتباط التفضيلية:',
    preferenceCookiesDesc: 'تذكر إعداداتك وتفضيلاتك',
    marketingCookies: 'ملفات تعريف الارتباط التسويقية:',
    marketingCookiesDesc: 'تتبع الزوار عبر مواقع الويب لعرض إعلانات ذات صلة',
    managingCookies: 'إدارة ملفات تعريف الارتباط',
    managingCookiesDesc: 'تتيح لك معظم متصفحات الويب التحكم في ملفات تعريف الارتباط من خلال إعداداتها. ومع ذلك، إذا قمت بتحديد قدرة مواقع الويب على تعيين ملفات تعريف الارتباط، فقد تؤثر على تجربة المستخدم الإجمالية.',
    thirdPartyCookies: 'ملفات تعريف الارتباط من جهات خارجية',
    thirdPartyCookiesDesc: 'قد نستخدم مقدمي خدمات من جهات خارجية لمراقبة وتحليل استخدام خدمتنا. لدى هذه الجهات الخارجية سياسات خصوصية خاصة بها تتناول كيفية استخدامها لهذه المعلومات.',

    // GDPR Compliance
    gdprComplianceTitle: 'الامتثال لـ GDPR',
    gdprComplianceSubtitle: 'ملتزمون بحماية خصوصيتك وضمان الامتثال لـ GDPR',
    gdprCompliantBadge: 'متوافق مع GDPR',
    yourRightsUnderGDPR: 'حقوقك بموجب GDPR',
    rightToAccess: 'الحق في الوصول',
    rightToAccessDesc: 'طلب نسخ من بياناتك الشخصية',
    rightToRectification: 'الحق في التصحيح',
    rightToRectificationDesc: 'طلب تصحيح البيانات غير الدقيقة أو غير الكاملة',
    rightToErasure: 'الحق في المحو',
    rightToErasureDesc: 'طلب حذف بياناتك الشخصية',
    rightToDataPortability: 'الحق في نقل البيانات',
    rightToDataPortabilityDesc: 'طلب نقل بياناتك إلى منظمة أخرى',
    dataProtectionMeasures: 'تدابير حماية البيانات',
    dataProtection1: 'تشفير البيانات أثناء النقل والتخزين',
    dataProtection2: 'عمليات تدقيق وتقييمات أمنية منتظمة',
    dataProtection3: 'تدريب الموظفين على حماية البيانات',
    dataProtection4: 'ضوابط صارمة للوصول والمصادقة',
    dataProtection5: 'إجراءات الإخطار بانتهاك البيانات',
    contactDPO: 'اتصل بمسؤول حماية البيانات لدينا',
    contactDPODesc: 'لأي استفسارات متعلقة بـ GDPR أو لممارسة حقوقك، يرجى الاتصال بمسؤول حماية البيانات لدينا:',

    // Blog Management
    blogManagement: 'إدارة المدونة',
    blogManagementDesc: 'إنشاء وإدارة منشورات مدونتك',
    createNewPost: 'إنشاء منشور جديد',
    editPost: 'تعديل المنشور',
    deletePost: 'حذف المنشور',
    publishPost: 'نشر المنشور',
    draftPost: 'حفظ كمسودة',
    postTitle: 'عنوان المنشور',
    postContent: 'محتوى المنشور',
    postCategory: 'الفئة',
    postStatus: 'الحالة',
    published: 'منشور',
    draft: 'مسودة',
    scheduled: 'مجدول',
    postDate: 'تاريخ المنشور',
    author: 'الكاتب',
    views: 'المشاهدات',
    comments: 'التعليقات',
    editBlogPost: 'تعديل منشور المدونة',
    deleteBlogPost: 'حذف منشور المدونة',
    noBlogPostsFound: 'لم يتم العثور على منشورات',
    createFirstPost: 'أنشئ أول منشور لك للبدء',
    postTitlePlaceholder: 'أدخل عنوان المنشور...',
    postContentPlaceholder: 'اكتب محتوى منشور مدونتك هنا...',
    selectCategory: 'اختر فئة',
    featuredImage: 'الصورة المميزة',
    uploadImage: 'رفع صورة',
    publishDate: 'تاريخ النشر',
    postExcerpt: 'مقتطف المنشور',
    postExcerptPlaceholder: 'ملخص مختصر لمنشورك...',
    tags: 'الوسوم',
    tagsPlaceholder: 'أضف وسوماً مفصولة بفواصل',
    postPublished: 'تم نشر المنشور بنجاح',
    postSaved: 'تم حفظ المنشور كمسودة',
    postDeleted: 'تم حذف المنشور بنجاح',

    // Manufacturer Onboarding
    manufacturerOnboarding: 'تسجيل المصنع',
    sourceDirectlyFromFactories: 'التوريد مباشرة من مصانع مصر المعتمدة',
    registerYourFactoryTitle: 'سجل مصنعك',
    registerYourFactoryDesc: 'انضم إلى منصة B2B الرائدة للتصنيع النسيجي في مصر. قدم معلومات مصنعك للتحقق وابدأ التواصل مع المشترين العالميين.',
    checkingAuthentication: 'جاري التحقق من المصادقة...',

    // Onboarding Steps
    companyInfo: 'معلومات الشركة',
    factoryDetails: 'تفاصيل المصنع',
    yourProducts: 'منتجاتك',
    documents: 'المستندات',
    subscription: 'الاشتراك',

    // Step 1: Company Information
    companyInformation: 'معلومات الشركة',
    companyName: 'اسم الشركة',
    companyNamePlaceholder: 'شركة EgypTex للتصنيع',
    businessLicenseNumber: 'رقم الترخيص التجاري',
    businessLicenseNumberPlaceholder: '12345678',
    establishedYear: 'سنة التأسيس',
    establishedYearPlaceholder: '2010',
    locationGovernorate: 'الموقع (المحافظة)',
    selectLocation: 'اختر الموقع',
    cairo: 'القاهرة',
    alexandria: 'الإسكندرية',
    giza: 'الجيزة',
    tenthOfRamadan: 'العاشر من رمضان',
    sixthOfOctober: 'السادس من أكتوبر',
    borgElArab: 'برج العرب',
    other: 'أخرى',
    fullAddress: 'العنوان الكامل',
    fullAddressPlaceholder: 'عنوان الشارع، المدينة، الرمز البريدي',
    website: 'الموقع الإلكتروني',
    websitePlaceholder: 'https://yourcompany.com',
    phoneNumber: 'رقم الهاتف',
    phoneNumberPlaceholder: '+20 XXX XXX XXXX',

    // Step 2: Factory Details
    factorySize: 'مساحة المصنع (متر مربع)',
    factorySizePlaceholder: '5000',
    numberOfEmployees: 'عدد الموظفين',
    numberOfEmployeesPlaceholder: '150',
    productionCapacity: 'الطاقة الإنتاجية (شهرياً)',
    productionCapacityPlaceholder: '100,000 متر من القماش',
    mainCategory: 'الفئة الرئيسية',
    selectMainCategory: 'اختر الفئة الرئيسية',
    yarnAndSpinning: 'غزل وخيوط',
    fabricsAndTextiles: 'أقمشة ومنسوجات',
    accessoriesAndTrims: 'إكسسوارات ومكملات',
    textileMachineryCategory: 'ماكينات نسيج',
    others: 'أخرى',

    // Step 3: Products
    productNumber: 'منتج رقم',
    productName: 'اسم المنتج',
    productNamePlaceholder: 'قماش قطن مصري 100%',
    productDescription: 'وصف المنتج',
    productDescriptionPlaceholder: 'وصف تفصيلي يتضمن المواصفات، المواد، الاستخدامات...',
    minimumOrderQuantity: 'الحد الأدنى للطلب',
    minimumOrderQuantityPlaceholder: '1000 متر',
    priceRange: 'نطاق السعر (جنيه مصري - EGP)',
    priceRangePlaceholder: '$5 - $15 للمتر',

    // Step 4: Documents
    documentsVerification: 'المستندات والتحقق',
    requiredDocuments: 'المستندات المطلوبة',
    businessLicensePdf: 'الترخيص التجاري (PDF، حد أقصى 5 ميجابايت)',
    certificationDocsOptional: 'مستندات الشهادات (اختياري، PDF)',
    productImagesDocs: 'صور المنتجات (JPG/PNG، حد أقصى 2 ميجابايت لكل صورة)',
    businessLicense: 'الترخيص التجاري',
    clickToUpload: 'انقر للتحميل أو اسحب وأفلت',
    pdfMax5mb: 'PDF (حد أقصى 5 ميجابايت)',
    fileUploaded: 'تم تحميل الملف',
    certificationDocuments: 'مستندات الشهادات (اختياري)',
    uploadCertificates: 'قم بتحميل شهاداتك (ISO، OEKO-TEX، إلخ)',
    pdfMax5mbMultiple: 'PDF (حد أقصى 5 ميجابايت لكل ملف، يسمح بملفات متعددة)',
    filesSelected: 'ملف (ملفات) محددة',
    whatHappensNext: 'ماذا سيحدث بعد ذلك؟',
    verificationStep1: 'يراجع فريق التحقق لدينا طلبك (2-3 أيام عمل)',
    verificationStep2: 'سنتواصل معك إذا كانت هناك حاجة لمعلومات إضافية',
    verificationStep3: 'بمجرد الموافقة، يتم نشر ملف مصنعك على المنصة',
    verificationStep4: 'ابدأ في تلقي الاستفسارات من المشترين العالميين',

    // Step 5: Subscription
    chooseYourPlan: 'اختر خطتك',
    selectPlanDesc: 'اختر الخطة التي تناسب احتياجات عملك',
    monthly: 'شهري',
    yearly: 'سنوي',
    saveTwoMonths: 'وفر شهرين',
    freePlan: 'الخطة المجانية',
    freePlanArabic: 'Free Plan',
    free: 'مجاني',
    freeArabic: 'Free',
    basicAccountCreation: 'إنشاء حساب أساسي',
    simpleCompanyProfile: 'صفحة تعريف بسيطة',
    upTo3Products: 'حتى 3 منتجات',
    publicSearchResults: 'الظهور في نتائج البحث',
    threeInquiriesPerMonth: '3 استفسارات شهرياً',
    emailSupportPlan: 'دعم عبر الإيميل',
    standardPlan: 'الخطة المدفوعة',
    standardPlanArabic: 'Standard Plan',
    popular: 'الأكثر شعبية',
    egpMonthly: '1000 جنيه',
    egpMonthlyArabic: 'EGP 1,000',
    egpYearly: '10,000 جنيه',
    egpYearlyArabic: 'EGP 10,000',
    allFreeFeatures: 'كل مميزات المجانية',
    fullFactoryProfile: 'صفحة مصنع كاملة',
    upTo15Products: 'حتى 15 منتج',
    unlimitedInquiries: 'استفسارات غير محدودة',
    directMessaging: 'تواصل مباشر',
    higherVisibility: 'ظهور متقدم',
    applyToRfqs: 'التقديم على طلبات الشراء',
    prioritySupport: 'دعم أسرع',
    proPlan: 'الخطة الاحترافية',
    proPlanArabic: 'Pro Plan',
    egpProMonthly: '2000 جنيه',
    egpProMonthlyArabic: 'EGP 2,000',
    egpProYearly: '20,000 جنيه',
    egpProYearlyArabic: 'EGP 20,000',
    allStandardFeatures: 'كل مميزات المدفوعة',
    unlimitedProducts: 'منتجات غير محدودة',
    topPrioritySearch: 'أولوية قصوى في البحث',
    verifiedSupplierBadge: 'علامة Verified',
    homepageFeatured: 'إبراز في الصفحة الرئيسية',
    performanceAnalyticsPlan: 'تقارير أداء',
    dedicatedSupport: 'دعم مخصص',
    marketingCampaigns: 'حملات تسويق EgypTex',
    importantNotes: 'ملاحظات مهمة',
    startFreeUpgradeAnytime: 'يمكنك البدء بالخطة المجانية والترقية في أي وقت',
    yearlySavings: 'الخطط السنوية توفر شهرين (المدفوعة: 2,000 جنيه | الاحترافية: 4,000 جنيه)',
    switchBillingAnytime: 'يمكنك التبديل بين الشهري والسنوي في أي وقت',
    allPlansIncludeVerification: 'جميع الخطط تشمل عملية التحقق',
    paymentAfterApproval: 'الدفع يتم بعد الموافقة',
    yourSelection: 'اختيارك',
    plan: 'الخطة',
    billing: 'الفوترة',
    clickSubmitToComplete: 'اضغط "إرسال للمراجعة" أدناه لإكمال التسجيل',

    // Navigation Buttons
    previous: 'السابق',
    nextStep: 'الخطوة التالية',
    submitForReview: 'إرسال للمراجعة',
    submitting: 'جاري الإرسال...',
    backToHomepage: 'العودة للصفحة الرئيسية',

    // Required indicator
    required: '*',
  },

  fr: {
    // Navigation
    home: 'Accueil',
    manufacturers: 'Fabricants',
    products: 'Produits',
    more: 'Plus',
    inquiries: 'Demandes',
    dashboard: 'Tableau de bord',
    startSourcing: 'Commencer l\'approvisionnement',

    // Homepage
    heroTagline: 'Source directement depuis les usines vérifiées d\'Égypte',
    heroTitle: 'Connectez-vous avec des fabricants textiles égyptiens vérifiés',
    heroSubtitle: 'Accédez au coton égyptien premium, aux tissus techniques et à l\'excellence manufacturière. Rejoignez la principale passerelle B2B pour l\'approvisionnement textile mondial.',
    searchPlaceholder: 'Rechercher des fabricants, produits ou catégories...',
    searchButton: 'Rechercher',
    exploreCategories: 'Explorer les catégories',

    // Egyptian Textile Categories
    yarnSpinning: 'Fil et filature',
    yarnSpinningDesc: 'Fil de coton égyptien premium, polyester, fils mélangés et solutions industrielles de filature',
    fabricsTextiles: 'Tissus et textiles',
    fabricsTextilesDesc: 'Tissus tissés, tricotés, denim, toile et tissus techniques des fabricants égyptiens',
    accessoriesTrims: 'Accessoires et garnitures',
    accessoriesTrimsDesc: 'Boutons, fermetures éclair, étiquettes, rubans et accessoires textiles pour la fabrication de vêtements',
    textileMachinery: 'Machines textiles',
    textileMachineryDesc: 'Machines de filature, métiers à tisser, équipements de teinture et machines de production textile',

    // Visitor Actions
    whatWouldYouLikeToDo: 'Que souhaitez-vous faire?',
    browseManufacturersAction: 'Parcourir les fabricants',
    browseProductsAction: 'Parcourir les produits',
    sendInquiryAction: 'Envoyer une demande',
    orSearchDirectly: 'Ou rechercher directement:',

    // Featured Manufacturers
    featuredManufacturers: 'Fabricants vérifiés en vedette',
    featuredManufacturersDesc: 'Connectez-vous avec des fabricants de premier ordre qui ont démontré leur excellence en matière de qualité, de fiabilité et de service client.',
    verified: 'Vérifié',
    productsCount: 'Produits',
    responseRate: 'Taux de réponse',
    viewProfile: 'Voir le profil',
    viewAllManufacturers: 'Voir tous les fabricants',

    // Categories
    industryCategories: 'Catégories industrielles',
    categoriesDesc: 'Explorez notre gamme complète de catégories textiles et manufacturières. Trouvez exactement ce dont vous avez besoin avec un filtrage spécialisé.',
    totalCategories: 'Total des catégories',
    totalProductsInCategories: 'Total des produits',
    trending: 'Tendances',
    allCategories: 'Toutes les catégories',
    searchCategories: 'Rechercher des catégories...',
    exploreCategory: 'Explorer la catégorie',
    subcategories: 'Sous-catégories',

    // Manufacturer Directory
    manufacturerDirectory: 'Répertoire des fabricants',
    manufacturerDirectoryDesc: 'Connectez-vous avec des fabricants et fournisseurs textiles égyptiens vérifiés. Trouvez le partenaire parfait pour vos besoins commerciaux.',
    totalManufacturers: 'Total des fabricants',
    verifiedCompanies: 'Entreprises vérifiées',
    activeProducts: 'Produits actifs',
    monthlyInquiries: 'Demandes mensuelles',
    searchManufacturers: 'Rechercher des fabricants...',
    allLocations: 'Tous les emplacements',
    showing: 'Affichage',
    manufacturer: 'fabricant',
    manufacturers_plural: 'fabricants',
    location: 'Emplacement',
    since: 'Depuis',
    staff: 'Personnel',
    rating: 'évaluation',
    certifications: 'Certifications',
    noManufacturersFound: 'Aucun fabricant trouvé',
    tryAdjustingFilters: 'Essayez d\'ajuster vos critères de recherche ou vos filtres',

    // Product Catalog
    productCatalog: 'Catalogue de produits',
    productCatalogDesc: 'Parcourez notre vaste collection de produits textiles vérifiés de fabricants de confiance.',
    filters: 'Filtres',
    sortBy: 'Trier par',
    relevance: 'Pertinence',
    priceLowToHigh: 'Prix: Croissant',
    priceHighToLow: 'Prix: Décroissant',
    newest: 'Plus récent',
    searchProducts: 'Rechercher des produits...',
    minOrder: 'Commande minimum',
    sendInquiry: 'Envoyer une demande',

    // Sign In
    signIn: 'Se connecter',
    welcomeBack: 'Bon retour',
    signInDesc: 'Connectez-vous pour accéder à votre tableau de bord fournisseur et gérer vos opérations commerciales.',
    email: 'E-mail',
    password: 'Mot de passe',
    selectRole: 'Sélectionnez votre rôle',
    owner: 'Propriétaire',
    admin: 'Administrateur',
    ownerDesc: 'Accès complet à toutes les fonctionnalités',
    adminDesc: 'Gérer les opérations',

    // Common
    category: 'Catégorie',
    description: 'Description',
    noResultsFound: 'Aucun résultat trouvé',
    loading: 'Chargement...',
    error: 'Erreur',
    success: 'Succès',
    cancel: 'Annuler',
    save: 'Enregistrer',
    delete: 'Supprimer',
    edit: 'Modifier',
    view: 'Voir',

    // Vendor Dashboard
    vendorDashboard: 'Tableau de bord fournisseur',
    dashboardSubtitle: 'Gérez votre profil, vos produits et vos demandes depuis un seul endroit centralisé',
    overview: 'Aperçu',
    analytics: 'Analytique',
    profile: 'Profil',
    settings: 'Paramètres',
    navigation: 'Navigation',
    quickActions: 'Actions rapides',
    needHelp: 'Besoin d\'aide?',
    helpDescription: 'Consultez notre documentation ou contactez le support',
    viewDocs: 'Voir les documents',

    // Dashboard Stats
    totalProducts: 'Total des produits',
    activeInquiries: 'Demandes actives',
    profileViews: 'Vues du profil',
    profileCompletion: 'Complétude du profil',
    completeProfile: 'Compléter le profil',
    completeProfileDesc: 'Complétez votre profil pour augmenter la visibilité',
    missingInformation: 'Informations manquantes:',

    // Performance & Notifications
    performanceAnalytics: 'Analyse des performances',
    notifications: 'Notifications',
    all: 'Tout',
    approvals: 'Approbations',
    system: 'Système',
    messages: 'Messages',
    noNotificationsFound: 'Aucune notification trouvée',
    showLess: 'Afficher moins',
    viewAll: 'Voir tout',

    // Inquiries Table
    recentInquiries: 'Demandes récentes',
    buyer: 'Acheteur',
    product: 'Produit',
    quantity: 'Quantité',
    date: 'Date',
    priority: 'Priorité',
    status: 'Statut',
    action: 'Action',
    viewDetails: 'Voir les détails',
    high: 'Haute',
    medium: 'Moyenne',
    low: 'Basse',
    pending: 'En attente',
    responded: 'Répondu',
    closed: 'Fermé',

    // Product Management
    productCatalogManager: 'Catalogue de produits',
    addProduct: 'Ajouter un produit',
    allStatus: 'Tous les statuts',
    active: 'Actif',
    inactive: 'Inactif',
    stock: 'Stock',
    price: 'Prix',

    // Quick Actions
    addNewProduct: 'Ajouter un nouveau produit',
    addNewProductDesc: 'Ajouter un nouveau produit à votre catalogue',
    manageInquiries: 'Gérer les demandes',
    manageInquiriesDesc: 'Voir et répondre aux demandes des acheteurs',
    updateProfile: 'Mettre à jour le profil',
    updateProfileDesc: 'Compléter le profil de votre entreprise',

    // CTA Section
    ctaTitle: 'Prêt à transformer votre stratégie d\'approvisionnement?',
    ctaSubtitle: 'Rejoignez des milliers de professionnels des achats qui font confiance à EgypTex Gateway pour des connexions fiables et basées sur les données avec les fabricants.',
    browseManufacturers: 'Parcourir les fabricants',
    exploreProducts: 'Explorer les produits',
    trustedBy: 'Approuvé par les plus grandes entreprises du monde',
    fortune500: 'Entreprises Fortune 500',
    smeManufacturers: 'Fabricants PME',
    internationalTraders: 'Commerçants internationaux',

    // Footer
    connectingManufacturers: 'Connecting verified manufacturers with global buyers through data-driven precision.',
    platform: 'Plateforme',
    resources: 'Ressources',
    company: 'Entreprise',
    legal: 'Légal',
    sourcingGuide: 'Guide d\'approvisionnement',
    qualityStandards: 'Normes de qualité',
    verificationProcess: 'Processus de vérification',
    helpCenter: 'Centre d\'aide',
    aboutUs: 'À propos de nous',
    contact: 'Contact',
    blog: 'Blog',
    privacyPolicy: 'Politique de confidentialité',
    termsOfService: 'Conditions d\'utilisation',
    cookiePolicy: 'Politique des cookies',
    gdprCompliance: 'Conformité RGPD',
    allRightsReserved: 'Tous droits réservés',
    isoCertified: 'Certifié ISO 9001',
    gdprCompliant: 'Conforme au RGPD',

    // Success Stories
    successStories: 'Histoires de succès',
    successStoriesDesc: 'Résultats réels d\'entreprises qui ont transformé leur stratégie d\'approvisionnement avec EgypTex Gateway.',
    challenge: 'Défi',
    solution: 'Solution',
    results: 'Résultats',

    // Trust Indicators
    trustSecurity: 'Confiance et sécurité',
    trustSecurityDesc: 'Votre succès en matière d\'approvisionnement repose sur notre engagement envers la transparence, la sécurité et l\'assurance qualité.',
    verifiedManufacturers: 'Fabricants vérifiés',
    verifiedManufacturersDesc: 'Chaque fabricant fait l\'objet d\'une vérification rigoureuse comprenant l\'enregistrement commercial, les certifications et les évaluations de capacités.',
    securePlatform: 'Plateforme sécurisée',
    securePlatformDesc: 'Sécurité de niveau entreprise avec cryptage SSL, conformité RGPD et protocoles de traitement de données sécurisés.',
    qualityAssurance: 'Assurance qualité',
    qualityAssuranceDesc: 'Plateforme certifiée ISO 9001 avec surveillance continue et processus de contrôle de la qualité.',
    globalStandards: 'Normes mondiales',
    globalStandardsDesc: 'Conformité aux réglementations commerciales internationales et aux normes de qualité spécifiques à l\'industrie.',
    platformCertifications: 'Certifications et conformité de la plateforme',
    platformIso9001: 'ISO 9001:2015',
    platformSslSecured: 'Sécurisé SSL',
    platformSoc2: 'SOC 2 Type II',

    // Platform Metrics
    activeManufacturers: 'Fabricants actifs',
    productListings: 'Listes de produits',
    successfulConnections: 'Connexions réussies',
    averageResponseTime: 'Temps de réponse moyen',

    // Heritage Timeline
    ourHeritage: 'Notre héritage',
    legacyWovenThroughTime: 'Un héritage tissé à travers le temps',
    heritageTimelineDesc: 'Des métiers à tisser anciens aux usines modernes, la tradition textile égyptienne s\'étend sur des millénaires',
    ancientEgyptEra: 'Égypte ancienne',
    ancientEgyptYear: '3000 av. J.-C.',
    birthOfFineTextiles: 'La naissance des textiles fins',
    birthOfFineTextilesDesc: 'Les artisans égyptiens ont été les pionniers des techniques de tissage du lin qui produisaient des tissus si fins qu\'ils étaient prisés dans les civilisations anciennes. Les pharaons portaient du lin comme symbole de pureté et de lumière.',
    traditionalCraftsmanshipEra: 'Artisanat traditionnel',
    traditionalCraftsmanshipYear: '1000 - 1900 apr. J.-C.',
    generationsOfMastery: 'Générations de maîtrise',
    generationsOfMasteryDesc: 'Au fil des siècles, les artisans égyptiens ont perfectionné leurs compétences, transmettant les techniques de génération en génération. Le filage et le tissage à la main sont restés un art de précision et de patience.',
    modernEra: 'Ère moderne',
    modernEraYear: '1900 - Présent',
    globalExcellenceManufacturing: 'Excellence mondiale en fabrication',
    globalExcellenceManufacturingDesc: 'Le coton égyptien à longues fibres est devenu légendaire dans le monde entier. Aujourd\'hui, nous combinons l\'artisanat ancien avec une technologie de pointe pour produire des textiles qui répondent aux normes internationales les plus élevées.',

    // Egyptian Cotton Story
    theGoldStandard: 'La norme d\'or',
    egyptianLongStapleCotton: 'Coton égyptien à longues fibres',
    egyptianCottonDesc: 'Cultivé dans le delta fertile du Nil, notre coton est réputé dans le monde entier pour sa longueur, sa résistance et sa douceur exceptionnelles',
    extraLongStaple: 'Fibres extra-longues',
    extraLongStapleDesc: 'Des fibres mesurant 1,5 à 2 pouces créent une douceur et une durabilité inégalées',
    superiorStrength: 'Résistance supérieure',
    superiorStrengthDesc: 'Des fibres plus résistantes signifient des tissus qui durent plus longtemps et résistent au boulochage',
    naturalLuster: 'Lustre naturel',
    naturalLusterDesc: 'Éclat et douceur uniques qui s\'améliorent à chaque lavage',
    giftFromNile: 'Un cadeau du Nil',
    giftFromNileDesc1: 'Le sol alluvial riche du delta du Nil, combiné au climat unique de l\'Égypte, crée les conditions parfaites pour cultiver le Gossypium barbadense - la meilleure variété de coton au monde.',
    giftFromNileDesc2: 'Depuis l\'Antiquité, les textiles égyptiens ont été prisés dans toutes les civilisations. Les pharaons enveloppaient leurs momies dans du lin fin, et aujourd\'hui, les marques de luxe du monde recherchent le coton égyptien pour sa qualité inégalée.',
    giftFromNileDesc3: 'Lorsque vous choisissez les textiles égyptiens, vous choisissez un héritage d\'excellence qui s\'étend sur des millénaires.',
    meetOurManufacturers: 'Rencontrez nos fabricants',
    yearsOfHeritage: 'Années d\'héritage',
    fiberLength: 'Longueur des fibres',
    naturalPure: 'Naturel et pur',
    globalQuality: 'Qualité mondiale',

    // Search Modal
    searchModalTitle: 'Que souhaitez-vous trouver?',
    searchModalPlaceholder: 'Rechercher des fabricants, produits, catégories...',
    recentSearches: 'Recherches récentes',
    popularSearches: 'Recherches populaires',
    quickLinks: 'Liens rapides',
    clearSearch: 'Effacer',
    noRecentSearches: 'Aucune recherche récente',

    // Industry Categories (Additional)
    browseByIndustry: 'Parcourir par industrie',
    viewAllCategories: 'Voir toutes les catégories',

    // Common UI
    language: 'Langue',
    theme: 'Thème',
    light: 'Clair',
    dark: 'Sombre',

    // Product Catalog
    searchProductsPlaceholder: 'Rechercher des produits par nom, catégorie ou spécifications...',
    browseProductsDesc: 'Parcourez notre vaste base de données de produits et équipements industriels',
    productCatalogTitle: 'Catalogue de produits',
    productCatalogCount: 'Produits',

    // Manufacturer Directory Specific
    searchManufacturersPlaceholder: 'Rechercher des fabricants par nom, produits ou spécialisation...',

    // Help Center
    supportAvailable: 'Assistance 24/7',
    helpCenterDesc: 'Trouvez des réponses aux questions courantes et obtenez l\'aide dont vous avez besoin',
    searchForHelp: 'Rechercher de l\'aide...',
    faqTitle: 'Questions fréquemment posées',
    faqHowToFind: 'Comment puis-je trouver des fabricants sur la plateforme?',
    faqHowToFindAnswer: 'Utilisez notre fonction de recherche pour parcourir les fabricants par catégorie, emplacement ou spécialisation. Filtrez les résultats en fonction des certifications et des notes.',
    faqVerified: 'Tous les fabricants sont-ils vérifiés?',
    faqVerifiedAnswer: 'Oui, chaque fabricant subit notre processus de vérification rigoureux comprenant l\'enregistrement d\'entreprise, les certifications et les inspections d\'installations.',
    faqRequestQuote: 'Comment puis-je demander un devis?',
    faqRequestQuoteAnswer: 'Visitez le profil d\'un fabricant et cliquez sur "Envoyer une demande". Fournissez vos exigences et le fabricant répondra directement.',
    faqPayment: 'Quelles méthodes de paiement sont acceptées?',
    faqPaymentAnswer: 'Les conditions de paiement sont négociées directement entre vous et le fabricant. Nous recommandons d\'utiliser des méthodes de paiement sécurisées.',
    stillNeedHelp: 'Besoin d\'aide supplémentaire?',
    contactSupportTeam: 'Contactez notre équipe d\'assistance',
    emailSupport: 'Assistance par e-mail',
    phoneSupport: 'Assistance téléphonique',

    // Sourcing Guide
    sourcingGuideTitle: 'Guide d\'Approvisionnement',
    sourcingGuideSubtitle: 'Votre feuille de route complète pour trouver et travailler avec les partenaires de fabrication parfaits',
    comprehensiveGuide: 'Guide Complet',
    theSourcingProcess: 'Le Processus d\'Approvisionnement',
    defineRequirements: 'Définir Vos Exigences',
    defineRequirementsDesc: 'Commencez par définir clairement vos spécifications de produit, normes de qualité, MOQ, fourchette budgétaire et délai de livraison. Plus vos exigences sont détaillées, meilleurs seront les résultats.',
    searchFilter: 'Rechercher et Filtrer',
    searchFilterDesc: 'Utilisez nos puissants outils de recherche et filtres avancés pour affiner les fabricants par catégorie, emplacement, certifications, capacité de production et spécialisations.',
    verifyCompare: 'Vérifier et Comparer',
    verifyCompareDesc: 'Examinez les profils des fabricants, vérifiez les certifications, consultez les notes et avis, comparez les capacités et évaluez leur historique avec les acheteurs précédents.',
    requestQuotes: 'Demander des Devis',
    requestQuotesDesc: 'Contactez plusieurs fabricants via notre plateforme, demandez des devis détaillés, négociez les conditions et demandez des échantillons pour évaluer la qualité avant de prendre des décisions.',
    bestPractices: 'Meilleures Pratiques',
    verifyCredentials: 'Vérifier les Accréditations',
    verifyCredentialsDesc: 'Vérifiez toujours les licences commerciales et les certifications',
    reviewSamples: 'Examiner les Échantillons',
    reviewSamplesDesc: 'Demandez des échantillons de produits avant de passer des commandes en gros',
    clearCommunication: 'Communication Claire',
    clearCommunicationDesc: 'Maintenez une communication documentée et transparente',
    compareOptions: 'Comparer les Options',
    compareOptionsDesc: 'Obtenez des devis de plusieurs fabricants',
    writtenAgreements: 'Accords Écrits',
    writtenAgreementsDesc: 'Formalisez toujours les accords par écrit',
    setTimelines: 'Définir les Délais',
    setTimelinesDesc: 'Établissez des échéances et des jalons clairs',
    readyToStartSourcing: 'Prêt à Commencer l\'Approvisionnement?',
    browseMfgDirectory: 'Parcourez notre répertoire de fabricants vérifiés et connectez-vous avec des fournisseurs de confiance',

    // Quality Standards
    qualityStandardsTitle: 'Normes de Qualité',
    qualityStandardsSubtitle: 'Nous maintenons des normes de qualité rigoureuses pour garantir que tous les fabricants répondent aux exigences internationales',
    certifiedStandards: 'Normes Certifiées',
    requiredCertifications: 'Certifications Requises',
    iso9001: 'ISO 9001:2015',
    iso9001Desc: 'Systèmes de Gestion de la Qualité',
    iso14001: 'ISO 14001',
    iso14001Desc: 'Gestion Environnementale',
    oekoTex: 'OEKO-TEX Standard 100',
    oekoTexDesc: 'Sécurité des Produits Textiles',
    gots: 'GOTS',
    gotsDesc: 'Norme Mondiale des Textiles Biologiques',
    bci: 'BCI',
    bciDesc: 'Initiative pour un Meilleur Coton',
    wrap: 'WRAP',
    wrapDesc: 'Production Responsable Mondiale',
    ourQualityProcess: 'Notre Processus de Contrôle Qualité',
    initialVerification: 'Vérification Initiale',
    initialVerificationDesc: 'Examen des documents et vérification de l\'enregistrement de l\'entreprise',
    facilityInspection: 'Inspection des Installations',
    facilityInspectionDesc: 'Évaluation sur site des capacités de production',
    sampleTesting: 'Test d\'Échantillons',
    sampleTestingDesc: 'Évaluation de la qualité des échantillons de produits',
    ongoingMonitoring: 'Surveillance Continue',
    ongoingMonitoringDesc: 'Suivi continu des performances et recertification',
    committedToExcellence: 'Engagés envers l\'Excellence',
    committedToExcellenceDesc: 'Chaque fabricant sur notre plateforme fait l\'objet d\'une vérification approfondie et d\'une surveillance continue pour garantir le maintien des normes de qualité les plus élevées tout au long de votre partenariat.',

    // Verification Process
    verificationProcessTitle: 'Processus de Vérification',
    verificationProcessSubtitle: 'Notre vérification complète en 6 étapes garantit que vous vous connectez avec des fabricants crédibles et capables',
    rigorousVerification: 'Vérification Rigoureuse',
    businessRegistration: 'Vérification de l\'Enregistrement Commercial',
    businessRegistrationDesc: 'Nous vérifions les documents officiels d\'enregistrement commercial, les certificats fiscaux et la situation juridique pour garantir la légitimité.',
    certificationValidation: 'Validation des Certifications',
    certificationValidationDesc: 'Toutes les certifications de qualité, les accréditations industrielles et les documents de conformité sont soigneusement vérifiés et validés.',
    facilityInspectionTitle: 'Inspection des Installations',
    facilityInspectionDesc2: 'Visites sur site pour évaluer les capacités de production, les systèmes de contrôle qualité et les conditions de travail.',
    capabilityAssessment: 'Évaluation des Capacités',
    capabilityAssessmentDesc: 'Évaluation de la capacité de production, des capacités techniques, de l\'équipement et des processus de fabrication.',
    performanceMonitoring: 'Surveillance des Performances',
    performanceMonitoringDesc: 'Suivi continu des performances des fabricants, des retours des acheteurs et des indicateurs de qualité.',
    periodicReverification: 'Revérification Périodique',
    periodicReverificationDesc: 'Réévaluation régulière et renouvellement du statut de vérification pour maintenir les normes de qualité.',
    verifiedBadge: 'Badge Vérifié',
    verifiedBadgeDesc: 'Les fabricants qui terminent avec succès notre processus de vérification reçoivent un badge vérifié, vous donnant confiance en leur crédibilité et leurs capacités.',

    // Blog
    blogTitle: 'Blog',
    blogSubtitle: 'Perspectives, actualités et mises à jour du monde de l\'approvisionnement textile',
    industryInsights: 'Perspectives de l\'Industrie',
    sourcingTips: 'Conseils d\'Approvisionnement',
    qualityAssuranceCategory: 'Assurance Qualité',
    readMore: 'Lire Plus',
    blogPost1Title: 'L\'Avenir de la Fabrication Textile Égyptienne',
    blogPost1Excerpt: 'Explorer les tendances et innovations qui façonnent l\'industrie textile égyptienne...',
    blogPost2Title: 'Comment Choisir le Bon Fabricant Textile',
    blogPost2Excerpt: 'Un guide complet pour évaluer et sélectionner des partenaires de fabrication...',
    blogPost3Title: 'Normes de Qualité dans la Production Textile',
    blogPost3Excerpt: 'Comprendre les certifications de qualité internationales et leur importance...',

    // Privacy Policy
    privacyPolicyTitle: 'Politique de Confidentialité',
    lastUpdated: 'Dernière mise à jour',
    informationWeCollect: '1. Informations Que Nous Collectons',
    informationWeCollectDesc: 'Nous collectons les informations que vous nous fournissez directement, notamment le nom, l\'adresse e-mail, les informations sur l\'entreprise et toute autre information que vous choisissez de fournir.',
    howWeUseInfo: '2. Comment Nous Utilisons Vos Informations',
    howWeUseInfoDesc: 'Nous utilisons les informations que nous collectons pour:',
    howWeUseInfo1: 'Fournir, maintenir et améliorer nos services',
    howWeUseInfo2: 'Traiter et finaliser les transactions',
    howWeUseInfo3: 'Vous envoyer des avis techniques et des messages d\'assistance',
    howWeUseInfo4: 'Répondre à vos commentaires et questions',
    howWeUseInfo5: 'Surveiller et analyser les tendances, l\'utilisation et les activités',
    informationSharing: '3. Partage d\'Informations',
    informationSharingDesc: 'Nous ne partageons pas vos informations personnelles avec des tiers, sauf comme décrit dans cette politique ou avec votre consentement.',
    dataSecurity: '4. Sécurité des Données',
    dataSecurityDesc: 'Nous prenons des mesures raisonnables pour aider à protéger vos informations personnelles contre la perte, le vol, l\'utilisation abusive, l\'accès non autorisé, la divulgation, l\'altération et la destruction.',
    yourRights: '5. Vos Droits',
    yourRightsDesc: 'Vous avez le droit d\'accéder, de mettre à jour ou de supprimer vos informations personnelles à tout moment. Contactez-nous pour obtenir de l\'aide.',
    contactUsPolicy: '6. Nous Contacter',
    contactUsPolicyDesc: 'Si vous avez des questions concernant cette Politique de Confidentialité, veuillez nous contacter à',

    // Terms of Service
    termsOfServiceTitle: 'Conditions d\'Utilisation',
    acceptanceOfTerms: '1. Acceptation des Conditions',
    acceptanceOfTermsDesc: 'En accédant et en utilisant EgypTex Gateway, vous acceptez et acceptez d\'être lié par les termes et dispositions de cet accord.',
    useOfService: '2. Utilisation du Service',
    useOfServiceDesc: 'Vous acceptez d\'utiliser le service uniquement à des fins légales et conformément à ces Conditions. Vous acceptez de ne pas utiliser le service:',
    useOfService1: 'D\'une manière qui viole les lois ou réglementations applicables',
    useOfService2: 'Pour transmettre un contenu illégal, nuisible ou répréhensible',
    useOfService3: 'Pour usurper l\'identité ou tenter d\'usurper l\'identité d\'une autre personne ou entité',
    useOfService4: 'Pour participer à toute conduite qui restreint l\'utilisation du service par quiconque',
    userAccounts: '3. Comptes Utilisateur',
    userAccountsDesc: 'Lorsque vous créez un compte, vous devez fournir des informations exactes et complètes. Vous êtes responsable du maintien de la confidentialité de vos identifiants de compte.',
    intellectualProperty: '4. Propriété Intellectuelle',
    intellectualPropertyDesc: 'Le service et son contenu, ses fonctionnalités et ses fonctionnalités originaux sont la propriété d\'EgypTex Gateway et sont protégés par les lois internationales sur les droits d\'auteur, les marques et autres propriétés intellectuelles.',
    limitationOfLiability: '5. Limitation de Responsabilité',
    limitationOfLiabilityDesc: 'En aucun cas EgypTex Gateway ne sera responsable des dommages indirects, accessoires, spéciaux, consécutifs ou punitifs résultant de votre utilisation du service.',
    contactInfoLegal: '6. Informations de Contact',
    contactInfoLegalDesc: 'Pour toute question concernant ces Conditions, veuillez nous contacter à',

    // Cookie Policy
    cookiePolicyTitle: 'Politique de Cookies',
    whatAreCookies: 'Qu\'est-ce que les Cookies',
    whatAreCookiesDesc: 'Les cookies sont de petits fichiers texte placés sur votre appareil lorsque vous visitez un site Web. Ils sont largement utilisés pour faire fonctionner les sites Web plus efficacement et fournir des informations aux propriétaires de sites Web.',
    howWeUseCookies: 'Comment Nous Utilisons les Cookies',
    howWeUseCookiesDesc: 'Nous utilisons des cookies aux fins suivantes:',
    essentialCookies: 'Cookies Essentiels:',
    essentialCookiesDesc: 'Requis pour que le site Web fonctionne correctement',
    analyticsCookies: 'Cookies Analytiques:',
    analyticsCookiesDesc: 'Nous aident à comprendre comment les visiteurs interagissent avec notre site Web',
    preferenceCookies: 'Cookies de Préférence:',
    preferenceCookiesDesc: 'Mémorisent vos paramètres et préférences',
    marketingCookies: 'Cookies Marketing:',
    marketingCookiesDesc: 'Suivent les visiteurs sur les sites Web pour afficher des publicités pertinentes',
    managingCookies: 'Gestion des Cookies',
    managingCookiesDesc: 'La plupart des navigateurs Web vous permettent de contrôler les cookies via leurs paramètres. Cependant, si vous limitez la capacité des sites Web à définir des cookies, vous pouvez impacter votre expérience utilisateur globale.',
    thirdPartyCookies: 'Cookies Tiers',
    thirdPartyCookiesDesc: 'Nous pouvons utiliser des fournisseurs de services tiers pour surveiller et analyser l\'utilisation de notre service. Ces tiers ont leurs propres politiques de confidentialité traitant de la manière dont ils utilisent ces informations.',

    // GDPR Compliance
    gdprComplianceTitle: 'Conformité RGPD',
    gdprComplianceSubtitle: 'Engagés à protéger votre vie privée et à garantir la conformité au RGPD',
    gdprCompliantBadge: 'Conforme au RGPD',
    yourRightsUnderGDPR: 'Vos Droits en Vertu du RGPD',
    rightToAccess: 'Droit d\'Accès',
    rightToAccessDesc: 'Demander des copies de vos données personnelles',
    rightToRectification: 'Droit de Rectification',
    rightToRectificationDesc: 'Demander la correction de données inexactes ou incomplètes',
    rightToErasure: 'Droit à l\'Effacement',
    rightToErasureDesc: 'Demander la suppression de vos données personnelles',
    rightToDataPortability: 'Droit à la Portabilité des Données',
    rightToDataPortabilityDesc: 'Demander le transfert de vos données vers une autre organisation',
    dataProtectionMeasures: 'Mesures de Protection des Données',
    dataProtection1: 'Chiffrement des données en transit et au repos',
    dataProtection2: 'Audits de sécurité et évaluations réguliers',
    dataProtection3: 'Formation du personnel sur la protection des données',
    dataProtection4: 'Contrôles d\'accès et authentification stricts',
    dataProtection5: 'Procédures de notification des violations de données',
    contactDPO: 'Contactez Notre Délégué à la Protection des Données',
    contactDPODesc: 'Pour toute demande liée au RGPD ou pour exercer vos droits, veuillez contacter notre DPO:',

    // Blog Management
    blogManagement: 'Gestion du Blog',
    blogManagementDesc: 'Créer et gérer vos articles de blog',
    createNewPost: 'Créer un Nouvel Article',
    editPost: 'Modifier l\'Article',
    deletePost: 'Supprimer l\'Article',
    publishPost: 'Publier l\'Article',
    draftPost: 'Enregistrer comme Brouillon',
    postTitle: 'Titre de l\'Article',
    postContent: 'Contenu de l\'Article',
    postCategory: 'Catégorie',
    postStatus: 'Statut',
    published: 'Publié',
    draft: 'Brouillon',
    scheduled: 'Programmé',
    postDate: 'Date de Publication',
    author: 'Auteur',
    views: 'Vues',
    comments: 'Commentaires',
    editBlogPost: 'Modifier l\'Article',
    deleteBlogPost: 'Supprimer l\'Article',
    noBlogPostsFound: 'Aucun article trouvé',
    createFirstPost: 'Créez votre premier article pour commencer',
    postTitlePlaceholder: 'Entrez le titre de l\'article...',
    postContentPlaceholder: 'Écrivez le contenu de votre article ici...',
    selectCategory: 'Sélectionner une catégorie',
    featuredImage: 'Image à la Une',
    uploadImage: 'Télécharger une Image',
    publishDate: 'Date de Publication',
    postExcerpt: 'Extrait de l\'Article',
    postExcerptPlaceholder: 'Bref résumé de votre article...',
    tags: 'Étiquettes',
    tagsPlaceholder: 'Ajoutez des étiquettes séparées par des virgules',
    postPublished: 'Article publié avec succès',
    postSaved: 'Article enregistré comme brouillon',
    postDeleted: 'Article supprimé avec succès',

    // Manufacturer Onboarding
    manufacturerOnboarding: 'Inscription du Fabricant',
    sourceDirectlyFromFactories: 'Approvisionnez-vous directement auprès des usines vérifiées d\'Égypte',
    registerYourFactoryTitle: 'Enregistrez Votre Usine',
    registerYourFactoryDesc: 'Rejoignez la principale plateforme B2B de fabrication textile d\'Égypte. Soumettez les informations de votre usine pour vérification et commencez à vous connecter avec des acheteurs mondiaux.',
    checkingAuthentication: 'Vérification de l\'authentification...',

    // Onboarding Steps
    companyInfo: 'Infos Entreprise',
    factoryDetails: 'Détails de l\'Usine',
    yourProducts: 'Vos Produits',
    documents: 'Documents',
    subscription: 'Abonnement',

    // Step 1: Company Information
    companyInformation: 'Informations sur l\'Entreprise',
    companyName: 'Nom de l\'Entreprise',
    companyNamePlaceholder: 'EgypTex Manufacturing Co.',
    businessLicenseNumber: 'Numéro de Licence Commerciale',
    businessLicenseNumberPlaceholder: '12345678',
    establishedYear: 'Année de Création',
    establishedYearPlaceholder: '2010',
    locationGovernorate: 'Localisation (Gouvernorat)',
    selectLocation: 'Sélectionner l\'emplacement',
    cairo: 'Le Caire',
    alexandria: 'Alexandrie',
    giza: 'Gizeh',
    tenthOfRamadan: '10ème de Ramadan',
    sixthOfOctober: '6 Octobre',
    borgElArab: 'Borg El Arab',
    other: 'Autre',
    fullAddress: 'Adresse Complète',
    fullAddressPlaceholder: 'Adresse, ville, code postal',
    website: 'Site Web',
    websitePlaceholder: 'https://votreentreprise.com',
    phoneNumber: 'Numéro de Téléphone',
    phoneNumberPlaceholder: '+20 XXX XXX XXXX',

    // Step 2: Factory Details
    factorySize: 'Taille de l\'Usine (m²)',
    factorySizePlaceholder: '5000',
    numberOfEmployees: 'Nombre d\'Employés',
    numberOfEmployeesPlaceholder: '150',
    productionCapacity: 'Capacité de Production (par mois)',
    productionCapacityPlaceholder: '100 000 mètres de tissu',
    mainCategory: 'Catégorie Principale',
    selectMainCategory: 'Sélectionner la catégorie principale',
    yarnAndSpinning: 'Fil et Filature',
    fabricsAndTextiles: 'Tissus et Textiles',
    accessoriesAndTrims: 'Accessoires et Garnitures',
    textileMachineryCategory: 'Machines Textiles',
    others: 'Autres',

    // Step 3: Products
    productNumber: 'Produit n°',
    productName: 'Nom du Produit',
    productNamePlaceholder: 'Tissu en Coton Égyptien 100%',
    productDescription: 'Description du Produit',
    productDescriptionPlaceholder: 'Description détaillée incluant spécifications, matériaux, utilisations...',
    minimumOrderQuantity: 'Quantité Minimum de Commande',
    minimumOrderQuantityPlaceholder: '1000 mètres',
    priceRange: 'Fourchette de Prix (Livres Égyptiennes - EGP)',
    priceRangePlaceholder: '$5 - $15 par mètre',

    // Step 4: Documents
    documentsVerification: 'Documents et Vérification',
    requiredDocuments: 'Documents Requis',
    businessLicensePdf: 'Licence Commerciale (PDF, max 5 Mo)',
    certificationDocsOptional: 'Documents de Certification (Optionnel, PDF)',
    productImagesDocs: 'Images de Produits (JPG/PNG, max 2 Mo chacune)',
    businessLicense: 'Licence Commerciale',
    clickToUpload: 'Cliquez pour télécharger ou glissez-déposez',
    pdfMax5mb: 'PDF (max 5 Mo)',
    fileUploaded: 'Fichier téléchargé',
    certificationDocuments: 'Documents de Certification (Optionnel)',
    uploadCertificates: 'Téléchargez vos certificats (ISO, OEKO-TEX, etc.)',
    pdfMax5mbMultiple: 'PDF (max 5 Mo chacun, plusieurs fichiers autorisés)',
    filesSelected: 'fichier(s) sélectionné(s)',
    whatHappensNext: 'Que se passe-t-il ensuite?',
    verificationStep1: 'Notre équipe de vérification examine votre soumission (2-3 jours ouvrables)',
    verificationStep2: 'Nous vous contacterons si des informations supplémentaires sont nécessaires',
    verificationStep3: 'Une fois approuvé, votre profil d\'usine sera mis en ligne sur la plateforme',
    verificationStep4: 'Commencez à recevoir des demandes d\'acheteurs mondiaux',

    // Step 5: Subscription
    chooseYourPlan: 'Choisissez Votre Plan',
    selectPlanDesc: 'Sélectionnez le plan qui correspond le mieux aux besoins de votre entreprise',
    monthly: 'Mensuel',
    yearly: 'Annuel',
    saveTwoMonths: 'Économisez 2 mois',
    freePlan: 'Plan Gratuit',
    freePlanArabic: 'الخطة المجانية',
    free: 'Gratuit',
    freeArabic: 'مجاني',
    basicAccountCreation: 'Création de compte de base',
    simpleCompanyProfile: 'Profil d\'entreprise simple',
    upTo3Products: 'Jusqu\'à 3 produits',
    publicSearchResults: 'Résultats de recherche publics',
    threeInquiriesPerMonth: '3 demandes/mois',
    emailSupportPlan: 'Support par e-mail',
    standardPlan: 'Plan Standard',
    standardPlanArabic: 'الخطة المدفوعة',
    popular: 'POPULAIRE',
    egpMonthly: '1 000 EGP',
    egpMonthlyArabic: '1000 جنيه / شهريًا',
    egpYearly: '10 000 EGP',
    egpYearlyArabic: '10,000 جنيه / سنويًا',
    allFreeFeatures: 'Toutes les fonctionnalités gratuites',
    fullFactoryProfile: 'Profil d\'usine complet',
    upTo15Products: 'Jusqu\'à 15 produits',
    unlimitedInquiries: 'Demandes illimitées',
    directMessaging: 'Messagerie directe',
    higherVisibility: 'Visibilité accrue',
    applyToRfqs: 'Postuler aux appels d\'offres',
    prioritySupport: 'Support prioritaire',
    proPlan: 'Plan Pro',
    proPlanArabic: 'الخطة الاحترافية',
    egpProMonthly: '2 000 EGP',
    egpProMonthlyArabic: '2000 جنيه / شهريًا',
    egpProYearly: '20 000 EGP',
    egpProYearlyArabic: '20,000 جنيه / سنويًا',
    allStandardFeatures: 'Toutes les fonctionnalités standard',
    unlimitedProducts: 'Produits illimités',
    topPrioritySearch: 'Recherche prioritaire',
    verifiedSupplierBadge: 'Badge Fournisseur Vérifié',
    homepageFeatured: 'Mis en avant sur la page d\'accueil',
    performanceAnalyticsPlan: 'Analyses de performance',
    dedicatedSupport: 'Support dédié',
    marketingCampaigns: 'Campagnes marketing',
    importantNotes: 'Notes Importantes',
    startFreeUpgradeAnytime: 'Vous pouvez commencer avec le plan gratuit et mettre à niveau à tout moment',
    yearlySavings: 'Les plans annuels vous font économiser 2 mois (Standard: 2 000 EGP | Pro: 4 000 EGP)',
    switchBillingAnytime: 'Changez entre facturation mensuelle et annuelle à tout moment',
    allPlansIncludeVerification: 'Tous les plans incluent notre processus de vérification',
    paymentAfterApproval: 'Le paiement sera traité après approbation',
    yourSelection: 'Votre Sélection',
    plan: 'Plan',
    billing: 'Facturation',
    clickSubmitToComplete: 'Cliquez sur "Soumettre pour Révision" ci-dessous pour compléter votre inscription',

    // Navigation Buttons
    previous: 'Précédent',
    nextStep: 'Étape Suivante',
    submitForReview: 'Soumettre pour Révision',
    submitting: 'Soumission en cours...',
    backToHomepage: 'Retour à l\'Accueil',

    // Required indicator
    required: '*',
  },

  de: {
    // Navigation
    home: 'Startseite',
    manufacturers: 'Hersteller',
    products: 'Produkte',
    more: 'Mehr',
    inquiries: 'Anfragen',
    dashboard: 'Dashboard',
    startSourcing: 'Beschaffung starten',

    // Homepage
    heroTagline: 'Beziehen Sie direkt von verifizierten Fabriken aus Ägypten',
    heroTitle: 'Verbinden Sie sich mit verifizierten ägyptischen Textilherstellern',
    heroSubtitle: 'Zugang zu Premium-ägyptischer Baumwolle, technischen Stoffen und Fertigungsexzellenz. Treten Sie dem führenden B2B-Gateway für globale Textilbeschaffung bei.',
    searchPlaceholder: 'Hersteller, Produkte oder Kategorien suchen...',
    searchButton: 'Suchen',
    exploreCategories: 'Kategorien erkunden',

    // Egyptian Textile Categories
    yarnSpinning: 'Garn und Spinnen',
    yarnSpinningDesc: 'Premium-ägyptisches Baumwollgarn, Polyester, Mischgarne und industrielle Spinnlösungen',
    fabricsTextiles: 'Stoffe und Textilien',
    fabricsTextilesDesc: 'Gewebte, gestrickte, Denim, Leinwand und technische Stoffe von ägyptischen Herstellern',
    accessoriesTrims: 'Zubehör und Besätze',
    accessoriesTrimsDesc: 'Knöpfe, Reißverschlüsse, Etiketten, Bänder und Textilzubehör für die Bekleidungsherstellung',
    textileMachinery: 'Textilmaschinen',
    textileMachineryDesc: 'Spinnmaschinen, Webstühle, Färbeanlagen und Textilproduktionsmaschinen',

    // Visitor Actions
    whatWouldYouLikeToDo: 'Was möchten Sie tun?',
    browseManufacturersAction: 'Hersteller durchsuchen',
    browseProductsAction: 'Produkte durchsuchen',
    sendInquiryAction: 'Anfrage senden',
    orSearchDirectly: 'Oder direkt suchen:',

    // Featured Manufacturers
    featuredManufacturers: 'Verifizierte Featured-Hersteller',
    featuredManufacturersDesc: 'Verbinden Sie sich mit Top-bewerteten Herstellern, die Exzellenz in Qualität, Zuverlässigkeit und Kundenservice demonstriert haben.',
    verified: 'Verifiziert',
    productsCount: 'Produkte',
    responseRate: 'Antwortrate',
    viewProfile: 'Profil ansehen',
    viewAllManufacturers: 'Alle Hersteller anzeigen',

    // Categories
    industryCategories: 'Industriekategorien',
    categoriesDesc: 'Erkunden Sie unsere umfassende Palette von Textil- und Fertigungskategorien. Finden Sie genau das, was Sie mit spezialisierter Filterung benötigen.',
    totalCategories: 'Gesamtkategorien',
    totalProductsInCategories: 'Gesamtprodukte',
    trending: 'Trending',
    allCategories: 'Alle Kategorien',
    searchCategories: 'Kategorien durchsuchen...',
    exploreCategory: 'Kategorie erkunden',
    subcategories: 'Unterkategorien',

    // Manufacturer Directory
    manufacturerDirectory: 'Herstellerverzeichnis',
    manufacturerDirectoryDesc: 'Verbinden Sie sich mit verifizierten ägyptischen Textilherstellern und Lieferanten. Finden Sie den perfekten Partner für Ihre Geschäftsbedürfnisse.',
    totalManufacturers: 'Gesamthersteller',
    verifiedCompanies: 'Verifizierte Unternehmen',
    activeProducts: 'Aktive Produkte',
    monthlyInquiries: 'Monatliche Anfragen',
    searchManufacturers: 'Hersteller suchen...',
    allLocations: 'Alle Standorte',
    showing: 'Anzeigen',
    manufacturer: 'Hersteller',
    manufacturers_plural: 'Hersteller',
    location: 'Standort',
    since: 'Seit',
    staff: 'Personal',
    rating: 'Bewertung',
    certifications: 'Zertifizierungen',
    noManufacturersFound: 'Keine Hersteller gefunden',
    tryAdjustingFilters: 'Versuchen Sie, Ihre Suchkriterien oder Filter anzupassen',

    // Product Catalog
    productCatalog: 'Produktkatalog',
    productCatalogDesc: 'Durchsuchen Sie unsere umfangreiche Sammlung verifizierter Textilprodukte von vertrauenswürdigen Herstellern.',
    filters: 'Filter',
    sortBy: 'Sortieren nach',
    relevance: 'Relevanz',
    priceLowToHigh: 'Preis: Aufsteigend',
    priceHighToLow: 'Preis: Absteigend',
    newest: 'Neueste',
    searchProducts: 'Produkte suchen...',
    minOrder: 'Mindestbestellung',
    sendInquiry: 'Anfrage senden',

    // Sign In
    signIn: 'Anmelden',
    welcomeBack: 'Willkommen zurück',
    signInDesc: 'Melden Sie sich an, um auf Ihr Lieferanten-Dashboard zuzugreifen und Ihre Geschäftsabläufe zu verwalten.',
    email: 'E-Mail',
    password: 'Passwort',
    selectRole: 'Wählen Sie Ihre Rolle',
    owner: 'Eigentümer',
    admin: 'Administrator',
    ownerDesc: 'Vollzugriff auf alle Funktionen',
    adminDesc: 'Operationen verwalten',

    // Common
    category: 'Kategorie',
    description: 'Beschreibung',
    noResultsFound: 'Keine Ergebnisse gefunden',
    loading: 'Lädt...',
    error: 'Fehler',
    success: 'Erfolg',
    cancel: 'Abbrechen',
    save: 'Speichern',
    delete: 'Löschen',
    edit: 'Bearbeiten',
    view: 'Ansehen',

    // Vendor Dashboard
    vendorDashboard: 'Lieferanten-Dashboard',
    dashboardSubtitle: 'Verwalten Sie Ihr Profil, Ihre Produkte und Anfragen von einem zentralen Ort aus',
    overview: 'Übersicht',
    analytics: 'Analytik',
    profile: 'Profil',
    settings: 'Einstellungen',
    navigation: 'Navigation',
    quickActions: 'Schnellaktionen',
    needHelp: 'Brauchen Sie Hilfe?',
    helpDescription: 'Sehen Sie sich unsere Dokumentation an oder kontaktieren Sie den Support',
    viewDocs: 'Dokumente anzeigen',

    // Dashboard Stats
    totalProducts: 'Gesamtprodukte',
    activeInquiries: 'Aktive Anfragen',
    profileViews: 'Profilansichten',
    profileCompletion: 'Profilvollständigkeit',
    completeProfile: 'Profil vervollständigen',
    completeProfileDesc: 'Vervollständigen Sie Ihr Profil, um die Sichtbarkeit zu erhöhen',
    missingInformation: 'Fehlende Informationen:',

    // Performance & Notifications
    performanceAnalytics: 'Leistungsanalyse',
    notifications: 'Benachrichtigungen',
    all: 'Alle',
    approvals: 'Genehmigungen',
    system: 'System',
    messages: 'Nachrichten',
    noNotificationsFound: 'Keine Benachrichtigungen gefunden',
    showLess: 'Weniger anzeigen',
    viewAll: 'Alle anzeigen',

    // Inquiries Table
    recentInquiries: 'Neueste Anfragen',
    buyer: 'Käufer',
    product: 'Produkt',
    quantity: 'Menge',
    date: 'Datum',
    priority: 'Priorität',
    status: 'Status',
    action: 'Aktion',
    viewDetails: 'Details anzeigen',
    high: 'Hoch',
    medium: 'Mittel',
    low: 'Niedrig',
    pending: 'Ausstehend',
    responded: 'Beantwortet',
    closed: 'Geschlossen',

    // Product Management
    productCatalogManager: 'Produktkatalog',
    addProduct: 'Produkt hinzufügen',
    allStatus: 'Alle Status',
    active: 'Aktiv',
    inactive: 'Inaktiv',
    stock: 'Bestand',
    price: 'Preis',

    // Quick Actions
    addNewProduct: 'Neues Produkt hinzufügen',
    addNewProductDesc: 'Neues Produkt zu Ihrem Katalog hinzufügen',
    manageInquiries: 'Anfragen verwalten',
    manageInquiriesDesc: 'Käuferanfragen anzeigen und beantworten',
    updateProfile: 'Profil aktualisieren',
    updateProfileDesc: 'Vervollständigen Sie Ihr Unternehmensprofil',

    // CTA Section
    ctaTitle: 'Bereit, Ihre Beschaffungsstrategie zu transformieren?',
    ctaSubtitle: 'Schließen Sie sich Tausenden von Beschaffungsexperten an, die EgypTex Gateway für zuverlässige, datengesteuerte Herstellerverbindungen vertrauen.',
    browseManufacturers: 'Hersteller durchsuchen',
    exploreProducts: 'Produkte erkunden',
    trustedBy: 'Vertraut von führenden Unternehmen weltweit',
    fortune500: 'Fortune 500 Unternehmen',
    smeManufacturers: 'KMU-Hersteller',
    internationalTraders: 'Internationale Händler',

    // Footer
    connectingManufacturers: 'Verbindung verifizierter Hersteller mit globalen Käufern durch datengesteuerte Präzision.',
    platform: 'Plattform',
    resources: 'Ressourcen',
    company: 'Unternehmen',
    legal: 'Rechtliches',
    sourcingGuide: 'Beschaffungshandbuch',
    qualityStandards: 'Qualitätsstandards',
    verificationProcess: 'Verifizierungsprozess',
    helpCenter: 'Hilfezentrum',
    aboutUs: 'Über uns',
    contact: 'Kontakt',
    blog: 'Blog',
    privacyPolicy: 'Datenschutzrichtlinie',
    termsOfService: 'Nutzungsbedingungen',
    cookiePolicy: 'Cookie-Richtlinie',
    gdprCompliance: 'DSGVO-Konformität',
    allRightsReserved: 'Alle Rechte vorbehalten',
    isoCertified: 'ISO 9001 zertifiziert',
    gdprCompliant: 'DSGVO-konform',

    // Success Stories
    successStories: 'Erfolgsgeschichten',
    successStoriesDesc: 'Echte Ergebnisse von Unternehmen, die ihre Beschaffungsstrategie mit EgypTex Gateway transformiert haben.',
    challenge: 'Herausforderung',
    solution: 'Lösung',
    results: 'Ergebnisse',

    // Trust Indicators
    trustSecurity: 'Vertrauen und Sicherheit',
    trustSecurityDesc: 'Ihr Beschaffungserfolg basiert auf unserem Engagement für Transparenz, Sicherheit und Qualitätssicherung.',
    verifiedManufacturers: 'Verifizierte Hersteller',
    verifiedManufacturersDesc: 'Jeder Hersteller durchläuft eine strenge Verifizierung einschließlich Geschäftsregistrierung, Zertifizierungen und Fähigkeitsbewertungen.',
    securePlatform: 'Sichere Plattform',
    securePlatformDesc: 'Unternehmenssicherheit mit SSL-Verschlüsselung, DSGVO-Konformität und sicheren Datenverarbeitungsprotokollen.',
    qualityAssurance: 'Qualitätssicherung',
    qualityAssuranceDesc: 'ISO 9001 zertifizierte Plattform mit kontinuierlicher Überwachung und Qualitätskontrollprozessen.',
    globalStandards: 'Globale Standards',
    globalStandardsDesc: 'Einhaltung internationaler Handelsvorschriften und branchenspezifischer Qualitätsstandards.',
    platformCertifications: 'Plattformzertifizierungen und Compliance',
    platformIso9001: 'ISO 9001:2015',
    platformSslSecured: 'SSL gesichert',
    platformSoc2: 'SOC 2 Type II',

    // Platform Metrics
    activeManufacturers: 'Aktive Hersteller',
    productListings: 'Produktlisten',
    successfulConnections: 'Erfolgreiche Verbindungen',
    averageResponseTime: 'Durchschnittliche Antwortzeit',

    // Heritage Timeline
    ourHeritage: 'Unser Erbe',
    legacyWovenThroughTime: 'Ein durch die Zeit gewobenes Erbe',
    heritageTimelineDesc: 'Von antiken Webstühlen bis zu modernen Fabriken erstreckt sich die ägyptische Textiltradition über Jahrtausende',
    ancientEgyptEra: 'Altes Ägypten',
    ancientEgyptYear: '3000 v. Chr.',
    birthOfFineTextiles: 'Die Geburt feiner Textilien',
    birthOfFineTextilesDesc: 'Ägyptische Handwerker waren Pioniere der Leinenwebtechniken, die Stoffe so fein produzierten, dass sie in antiken Zivilisationen geschätzt wurden. Pharaonen trugen Leinen als Symbol für Reinheit und Licht.',
    traditionalCraftsmanshipEra: 'Traditionelles Handwerk',
    traditionalCraftsmanshipYear: '1000 - 1900 n. Chr.',
    generationsOfMastery: 'Generationen der Meisterschaft',
    generationsOfMasteryDesc: 'Über Jahrhunderte hinweg verfeinerten ägyptische Handwerker ihre Fähigkeiten und gaben Techniken von Generation zu Generation weiter. Handspinnen und Weben blieben eine Kunstform der Präzision und Geduld.',
    modernEra: 'Moderne Ära',
    modernEraYear: '1900 - Gegenwart',
    globalExcellenceManufacturing: 'Globale Exzellenz in der Fertigung',
    globalExcellenceManufacturingDesc: 'Ägyptische langstapelige Baumwolle wurde weltweit legendär. Heute kombinieren wir altes Handwerk mit modernster Technologie, um Textilien zu produzieren, die höchsten internationalen Standards entsprechen.',

    // Egyptian Cotton Story
    theGoldStandard: 'Der Goldstandard',
    egyptianLongStapleCotton: 'Ägyptische langstapelige Baumwolle',
    egyptianCottonDesc: 'Angebaut im fruchtbaren Nildelta, ist unsere Baumwolle weltweit bekannt für ihre außergewöhnliche Länge, Stärke und Weichheit',
    extraLongStaple: 'Extra-lange Stapel',
    extraLongStapleDesc: 'Fasern mit einer Länge von 1,5-2 Zoll schaffen unvergleichliche Glätte und Haltbarkeit',
    superiorStrength: 'Überlegene Festigkeit',
    superiorStrengthDesc: 'Stärkere Fasern bedeuten Stoffe, die länger halten und Pilling widerstehen',
    naturalLuster: 'Natürlicher Glanz',
    naturalLusterDesc: 'Einzigartiger Glanz und Weichheit, die sich mit jeder Wäsche verbessern',
    giftFromNile: 'Ein Geschenk vom Nil',
    giftFromNileDesc1: 'Der reiche Schwemmlandboden des Nildeltas, kombiniert mit Ägyptens einzigartigem Klima, schafft die perfekten Bedingungen für den Anbau von Gossypium barbadense - der weltweit besten Baumwollsorte.',
    giftFromNileDesc2: 'Seit der Antike wurden ägyptische Textilien in allen Zivilisationen geschätzt. Pharaonen wickelten ihre Mumien in feines Leinen, und heute suchen die Luxusmarken der Welt ägyptische Baumwolle für ihre unvergleichliche Qualität.',
    giftFromNileDesc3: 'Wenn Sie ägyptische Textilien wählen, wählen Sie ein Erbe der Exzellenz, das sich über Jahrtausende erstreckt.',
    meetOurManufacturers: 'Lernen Sie unsere Hersteller kennen',
    yearsOfHeritage: 'Jahre des Erbes',
    fiberLength: 'Faserlänge',
    naturalPure: 'Natürlich & rein',
    globalQuality: 'Globale Qualität',

    // Search Modal
    searchModalTitle: 'Was möchten Sie finden?',
    searchModalPlaceholder: 'Hersteller, Produkte, Kategorien suchen...',
    recentSearches: 'Letzte Suchen',
    popularSearches: 'Beliebte Suchen',
    quickLinks: 'Schnellzugriffe',
    clearSearch: 'Löschen',
    noRecentSearches: 'Keine letzten Suchen',

    // Industry Categories (Additional)
    browseByIndustry: 'Nach Branche durchsuchen',
    viewAllCategories: 'Alle Kategorien anzeigen',

    // Common UI
    language: 'Sprache',
    theme: 'Thema',
    light: 'Hell',
    dark: 'Dunkel',

    // Product Catalog
    searchProductsPlaceholder: 'Produkte nach Name, Kategorie oder Spezifikationen suchen...',
    browseProductsDesc: 'Durchsuchen Sie unsere umfassende Datenbank mit Industrieprodukten und Geräten',
    productCatalogTitle: 'Produktkatalog',
    productCatalogCount: 'Produkte',

    // Manufacturer Directory Specific
    searchManufacturersPlaceholder: 'Hersteller nach Name, Produkten oder Spezialisierung suchen...',

    // Help Center
    supportAvailable: '24/7 Support',
    helpCenterDesc: 'Finden Sie Antworten auf häufig gestellte Fragen und erhalten Sie die Unterstützung, die Sie benötigen',
    searchForHelp: 'Nach Hilfe suchen...',
    faqTitle: 'Häufig gestellte Fragen',
    faqHowToFind: 'Wie finde ich Hersteller auf der Plattform?',
    faqHowToFindAnswer: 'Verwenden Sie unsere Suchfunktion, um Hersteller nach Kategorie, Standort oder Spezialisierung zu durchsuchen. Filtern Sie die Ergebnisse basierend auf Zertifizierungen und Bewertungen.',
    faqVerified: 'Sind alle Hersteller verifiziert?',
    faqVerifiedAnswer: 'Ja, jeder Hersteller durchläuft unseren strengen Verifizierungsprozess, einschließlich Unternehmensregistrierung, Zertifizierungen und Betriebsinspektionen.',
    faqRequestQuote: 'Wie fordere ich ein Angebot an?',
    faqRequestQuoteAnswer: 'Besuchen Sie das Profil eines Herstellers und klicken Sie auf "Anfrage senden". Geben Sie Ihre Anforderungen an und der Hersteller wird direkt antworten.',
    faqPayment: 'Welche Zahlungsmethoden werden akzeptiert?',
    faqPaymentAnswer: 'Die Zahlungsbedingungen werden direkt zwischen Ihnen und dem Hersteller ausgehandelt. Wir empfehlen die Verwendung sicherer Zahlungsmethoden.',
    stillNeedHelp: 'Benötigen Sie weitere Hilfe?',
    contactSupportTeam: 'Kontaktieren Sie unser Support-Team',
    emailSupport: 'E-Mail-Support',
    phoneSupport: 'Telefon-Support',

    // Sourcing Guide
    sourcingGuideTitle: 'Beschaffungsleitfaden',
    sourcingGuideSubtitle: 'Ihr vollständiger Fahrplan zum Finden und Arbeiten mit den perfekten Fertigungspartnern',
    comprehensiveGuide: 'Umfassender Leitfaden',
    theSourcingProcess: 'Der Beschaffungsprozess',
    defineRequirements: 'Definieren Sie Ihre Anforderungen',
    defineRequirementsDesc: 'Beginnen Sie damit, Ihre Produktspezifikationen, Qualitätsstandards, MOQ, Budgetrahmen und Liefertermin klar zu umreißen. Je detaillierter Ihre Anforderungen sind, desto bessere Übereinstimmungen finden Sie.',
    searchFilter: 'Suchen und Filtern',
    searchFilterDesc: 'Nutzen Sie unsere leistungsstarken Suchtools und erweiterten Filter, um Hersteller nach Kategorie, Standort, Zertifizierungen, Produktionskapazität und Spezialisierungen einzugrenzen.',
    verifyCompare: 'Überprüfen und Vergleichen',
    verifyCompareDesc: 'Überprüfen Sie Herstellerprofile, verifizieren Sie Zertifizierungen, prüfen Sie Bewertungen und Rezensionen, vergleichen Sie Fähigkeiten und bewerten Sie ihre Erfolgsbilanz mit früheren Käufern.',
    requestQuotes: 'Angebote Anfordern',
    requestQuotesDesc: 'Kontaktieren Sie mehrere Hersteller über unsere Plattform, fordern Sie detaillierte Angebote an, verhandeln Sie Bedingungen und fordern Sie Muster an, um die Qualität vor Entscheidungen zu bewerten.',
    bestPractices: 'Best Practices',
    verifyCredentials: 'Credentials Überprüfen',
    verifyCredentialsDesc: 'Überprüfen Sie immer Geschäftslizenzen und Zertifizierungen',
    reviewSamples: 'Muster Überprüfen',
    reviewSamplesDesc: 'Fordern Sie Produktmuster an, bevor Sie Großbestellungen aufgeben',
    clearCommunication: 'Klare Kommunikation',
    clearCommunicationDesc: 'Pflegen Sie dokumentierte und transparente Kommunikation',
    compareOptions: 'Optionen Vergleichen',
    compareOptionsDesc: 'Holen Sie Angebote von mehreren Herstellern ein',
    writtenAgreements: 'Schriftliche Vereinbarungen',
    writtenAgreementsDesc: 'Formalisieren Sie Vereinbarungen immer schriftlich',
    setTimelines: 'Zeitpläne Festlegen',
    setTimelinesDesc: 'Legen Sie klare Fristen und Meilensteine fest',
    readyToStartSourcing: 'Bereit, mit der Beschaffung zu beginnen?',
    browseMfgDirectory: 'Durchsuchen Sie unser Verzeichnis verifizierter Hersteller und verbinden Sie sich mit vertrauenswürdigen Lieferanten',

    // Quality Standards
    qualityStandardsTitle: 'Qualitätsstandards',
    qualityStandardsSubtitle: 'Wir pflegen strenge Qualitätsstandards, um sicherzustellen, dass alle Hersteller internationale Anforderungen erfüllen',
    certifiedStandards: 'Zertifizierte Standards',
    requiredCertifications: 'Erforderliche Zertifizierungen',
    iso9001: 'ISO 9001:2015',
    iso9001Desc: 'Qualitätsmanagementsysteme',
    iso14001: 'ISO 14001',
    iso14001Desc: 'Umweltmanagement',
    oekoTex: 'OEKO-TEX Standard 100',
    oekoTexDesc: 'Textilprodukt-Sicherheit',
    gots: 'GOTS',
    gotsDesc: 'Globaler Standard für Bio-Textilien',
    bci: 'BCI',
    bciDesc: 'Better Cotton Initiative',
    wrap: 'WRAP',
    wrapDesc: 'Weltweite Verantwortungsvolle Produktion',
    ourQualityProcess: 'Unser Qualitätskontrollprozess',
    initialVerification: 'Erstverifizierung',
    initialVerificationDesc: 'Dokumentenprüfung und Überprüfung der Geschäftsregistrierung',
    facilityInspection: 'Betriebsinspektion',
    facilityInspectionDesc: 'Vor-Ort-Bewertung der Produktionskapazitäten',
    sampleTesting: 'Musterpüfung',
    sampleTestingDesc: 'Qualitätsbewertung von Produktmustern',
    ongoingMonitoring: 'Laufende Überwachung',
    ongoingMonitoringDesc: 'Kontinuierliche Leistungsverfolgung und Rezertifizierung',
    committedToExcellence: 'Dem Streben nach Exzellenz verpflichtet',
    committedToExcellenceDesc: 'Jeder Hersteller auf unserer Plattform durchläuft eine gründliche Überprüfung und kontinuierliche Überwachung, um sicherzustellen, dass die höchsten Qualitätsstandards während Ihrer gesamten Partnerschaft eingehalten werden.',

    // Verification Process
    verificationProcessTitle: 'Verifizierungsprozess',
    verificationProcessSubtitle: 'Unsere umfassende 6-Schritte-Verifizierung stellt sicher, dass Sie sich mit glaubwürdigen und fähigen Herstellern verbinden',
    rigorousVerification: 'Strenge Verifizierung',
    businessRegistration: 'Verifizierung der Geschäftsregistrierung',
    businessRegistrationDesc: 'Wir überprüfen offizielle Geschäftsregistrierungsdokumente, Steuerzertifikate und den rechtlichen Status, um Legitimität sicherzustellen.',
    certificationValidation: 'Zertifizierungsvalidierung',
    certificationValidationDesc: 'Alle Qualitätszertifizierungen, Branchennachweise und Konformitätsdokumente werden gründlich geprüft und validiert.',
    facilityInspectionTitle: 'Betriebsinspektion',
    facilityInspectionDesc2: 'Vor-Ort-Besuche zur Bewertung von Produktionskapazitäten, Qualitätskontrollsystemen und Arbeitsbedingungen.',
    capabilityAssessment: 'Fähigkeitsbewertung',
    capabilityAssessmentDesc: 'Bewertung von Produktionskapazität, technischen Fähigkeiten, Ausrüstung und Fertigungsprozessen.',
    performanceMonitoring: 'Leistungsüberwachung',
    performanceMonitoringDesc: 'Kontinuierliche Verfolgung der Herstellerleistung, des Käufer-Feedbacks und der Qualitätsmetriken.',
    periodicReverification: 'Periodische Neuverifizierung',
    periodicReverificationDesc: 'Regelmäßige Neubewertung und Erneuerung des Verifizierungsstatus zur Aufrechterhaltung von Qualitätsstandards.',
    verifiedBadge: 'Verifiziertes Abzeichen',
    verifiedBadgeDesc: 'Hersteller, die unseren Verifizierungsprozess erfolgreich abschließen, erhalten ein verifiziertes Abzeichen, das Ihnen Vertrauen in ihre Glaubwürdigkeit und Fähigkeiten gibt.',

    // Blog
    blogTitle: 'Blog',
    blogSubtitle: 'Einblicke, Nachrichten und Updates aus der Welt der Textilbeschaffung',
    industryInsights: 'Branchen-Einblicke',
    sourcingTips: 'Beschaffungstipps',
    qualityAssuranceCategory: 'Qualitätssicherung',
    readMore: 'Weiterlesen',
    blogPost1Title: 'Die Zukunft der ägyptischen Textilherstellung',
    blogPost1Excerpt: 'Erforschung von Trends und Innovationen, die die ägyptische Textilindustrie prägen...',
    blogPost2Title: 'So wählen Sie den richtigen Textilhersteller',
    blogPost2Excerpt: 'Ein umfassender Leitfaden zur Bewertung und Auswahl von Fertigungspartnern...',
    blogPost3Title: 'Qualitätsstandards in der Textilproduktion',
    blogPost3Excerpt: 'Internationale Qualitätszertifizierungen und ihre Bedeutung verstehen...',

    // Privacy Policy
    privacyPolicyTitle: 'Datenschutzrichtlinie',
    lastUpdated: 'Zuletzt aktualisiert',
    informationWeCollect: '1. Informationen, die wir sammeln',
    informationWeCollectDesc: 'Wir sammeln Informationen, die Sie uns direkt zur Verfügung stellen, einschließlich Name, E-Mail-Adresse, Unternehmensinformationen und alle anderen Informationen, die Sie bereitstellen möchten.',
    howWeUseInfo: '2. Wie wir Ihre Informationen verwenden',
    howWeUseInfoDesc: 'Wir verwenden die gesammelten Informationen, um:',
    howWeUseInfo1: 'Unsere Dienste bereitzustellen, zu warten und zu verbessern',
    howWeUseInfo2: 'Transaktionen zu verarbeiten und abzuschließen',
    howWeUseInfo3: 'Ihnen technische Mitteilungen und Support-Nachrichten zu senden',
    howWeUseInfo4: 'Auf Ihre Kommentare und Fragen zu antworten',
    howWeUseInfo5: 'Trends, Nutzung und Aktivitäten zu überwachen und zu analysieren',
    informationSharing: '3. Weitergabe von Informationen',
    informationSharingDesc: 'Wir geben Ihre personenbezogenen Daten nicht an Dritte weiter, außer wie in dieser Richtlinie beschrieben oder mit Ihrer Zustimmung.',
    dataSecurity: '4. Datensicherheit',
    dataSecurityDesc: 'Wir ergreifen angemessene Maßnahmen, um Ihre personenbezogenen Daten vor Verlust, Diebstahl, Missbrauch, unbefugtem Zugriff, Offenlegung, Änderung und Zerstörung zu schützen.',
    yourRights: '5. Ihre Rechte',
    yourRightsDesc: 'Sie haben das Recht, jederzeit auf Ihre personenbezogenen Daten zuzugreifen, sie zu aktualisieren oder zu löschen. Kontaktieren Sie uns für Unterstützung.',
    contactUsPolicy: '6. Kontaktieren Sie uns',
    contactUsPolicyDesc: 'Wenn Sie Fragen zu dieser Datenschutzrichtlinie haben, kontaktieren Sie uns bitte unter',

    // Terms of Service
    termsOfServiceTitle: 'Nutzungsbedingungen',
    acceptanceOfTerms: '1. Annahme der Bedingungen',
    acceptanceOfTermsDesc: 'Durch den Zugriff auf und die Nutzung von EgypTex Gateway akzeptieren Sie die Bedingungen und Bestimmungen dieser Vereinbarung und stimmen ihnen zu.',
    useOfService: '2. Nutzung des Dienstes',
    useOfServiceDesc: 'Sie stimmen zu, den Dienst nur für rechtmäßige Zwecke und gemäß diesen Bedingungen zu nutzen. Sie verpflichten sich, den Dienst nicht zu nutzen:',
    useOfService1: 'Auf eine Weise, die geltende Gesetze oder Vorschriften verletzt',
    useOfService2: 'Um rechtswidrige, schädliche oder anstößige Inhalte zu übertragen',
    useOfService3: 'Um sich als eine andere Person oder Einrichtung auszugeben oder zu versuchen, sich auszugeben',
    useOfService4: 'Um sich an Verhaltensweisen zu beteiligen, die die Nutzung des Dienstes durch andere einschränken',
    userAccounts: '3. Benutzerkonten',
    userAccountsDesc: 'Wenn Sie ein Konto erstellen, müssen Sie genaue und vollständige Informationen bereitstellen. Sie sind für die Wahrung der Vertraulichkeit Ihrer Kontoanmeldeinformationen verantwortlich.',
    intellectualProperty: '4. Geistiges Eigentum',
    intellectualPropertyDesc: 'Der Dienst und seine ursprünglichen Inhalte, Merkmale und Funktionen sind Eigentum von EgypTex Gateway und durch internationale Urheberrechts-, Marken- und andere Gesetze zum Schutz des geistigen Eigentums geschützt.',
    limitationOfLiability: '5. Haftungsbeschränkung',
    limitationOfLiabilityDesc: 'In keinem Fall haftet EgypTex Gateway für indirekte, zufällige, besondere, Folge- oder Strafschäden, die sich aus Ihrer Nutzung des Dienstes ergeben.',
    contactInfoLegal: '6. Kontaktinformationen',
    contactInfoLegalDesc: 'Bei Fragen zu diesen Bedingungen kontaktieren Sie uns bitte unter',

    // Cookie Policy
    cookiePolicyTitle: 'Cookie-Richtlinie',
    whatAreCookies: 'Was sind Cookies',
    whatAreCookiesDesc: 'Cookies sind kleine Textdateien, die auf Ihrem Gerät platziert werden, wenn Sie eine Website besuchen. Sie werden häufig verwendet, um Websites effizienter arbeiten zu lassen und Informationen an Website-Besitzer zu liefern.',
    howWeUseCookies: 'Wie wir Cookies verwenden',
    howWeUseCookiesDesc: 'Wir verwenden Cookies für die folgenden Zwecke:',
    essentialCookies: 'Wesentliche Cookies:',
    essentialCookiesDesc: 'Erforderlich, damit die Website ordnungsgemäß funktioniert',
    analyticsCookies: 'Analytische Cookies:',
    analyticsCookiesDesc: 'Helfen uns zu verstehen, wie Besucher mit unserer Website interagieren',
    preferenceCookies: 'Präferenz-Cookies:',
    preferenceCookiesDesc: 'Merken sich Ihre Einstellungen und Präferenzen',
    marketingCookies: 'Marketing-Cookies:',
    marketingCookiesDesc: 'Verfolgen Besucher über Websites hinweg, um relevante Werbung anzuzeigen',
    managingCookies: 'Cookies verwalten',
    managingCookiesDesc: 'Die meisten Webbrowser ermöglichen es Ihnen, Cookies über ihre Einstellungen zu steuern. Wenn Sie jedoch die Fähigkeit von Websites zum Setzen von Cookies einschränken, können Sie Ihre Gesamterfahrung als Benutzer beeinträchtigen.',
    thirdPartyCookies: 'Cookies von Drittanbietern',
    thirdPartyCookiesDesc: 'Wir können Drittanbieter-Dienstleister verwenden, um die Nutzung unseres Dienstes zu überwachen und zu analysieren. Diese Dritten haben eigene Datenschutzrichtlinien, die sich damit befassen, wie sie solche Informationen verwenden.',

    // GDPR Compliance
    gdprComplianceTitle: 'DSGVO-Konformität',
    gdprComplianceSubtitle: 'Verpflichtet, Ihre Privatsphäre zu schützen und die Einhaltung der DSGVO zu gewährleisten',
    gdprCompliantBadge: 'DSGVO-konform',
    yourRightsUnderGDPR: 'Ihre Rechte gemäß DSGVO',
    rightToAccess: 'Recht auf Zugang',
    rightToAccessDesc: 'Kopien Ihrer personenbezogenen Daten anfordern',
    rightToRectification: 'Recht auf Berichtigung',
    rightToRectificationDesc: 'Korrektur ungenauer oder unvollständiger Daten anfordern',
    rightToErasure: 'Recht auf Löschung',
    rightToErasureDesc: 'Löschung Ihrer personenbezogenen Daten anfordern',
    rightToDataPortability: 'Recht auf Datenübertragbarkeit',
    rightToDataPortabilityDesc: 'Übertragung Ihrer Daten an eine andere Organisation anfordern',
    dataProtectionMeasures: 'Datenschutzmaßnahmen',
    dataProtection1: 'Verschlüsselung von Daten während der Übertragung und im Ruhezustand',
    dataProtection2: 'Regelmäßige Sicherheitsaudits und -bewertungen',
    dataProtection3: 'Schulung des Personals zum Datenschutz',
    dataProtection4: 'Strenge Zugriffskontrollen und Authentifizierung',
    dataProtection5: 'Verfahren zur Benachrichtigung bei Datenschutzverletzungen',
    contactDPO: 'Kontaktieren Sie unseren Datenschutzbeauftragten',
    contactDPODesc: 'Für DSGVO-bezogene Anfragen oder zur Ausübung Ihrer Rechte kontaktieren Sie bitte unseren DSB:',

    // Blog Management
    blogManagement: 'Blog-Verwaltung',
    blogManagementDesc: 'Erstellen und verwalten Sie Ihre Blogbeiträge',
    createNewPost: 'Neuen Beitrag Erstellen',
    editPost: 'Beitrag Bearbeiten',
    deletePost: 'Beitrag Löschen',
    publishPost: 'Beitrag Veröffentlichen',
    draftPost: 'Als Entwurf Speichern',
    postTitle: 'Beitragstitel',
    postContent: 'Beitragsinhalt',
    postCategory: 'Kategorie',
    postStatus: 'Status',
    published: 'Veröffentlicht',
    draft: 'Entwurf',
    scheduled: 'Geplant',
    postDate: 'Veröffentlichungsdatum',
    author: 'Autor',
    views: 'Aufrufe',
    comments: 'Kommentare',
    editBlogPost: 'Blogbeitrag Bearbeiten',
    deleteBlogPost: 'Blogbeitrag Löschen',
    noBlogPostsFound: 'Keine Blogbeiträge gefunden',
    createFirstPost: 'Erstellen Sie Ihren ersten Blogbeitrag, um loszulegen',
    postTitlePlaceholder: 'Beitragstitel eingeben...',
    postContentPlaceholder: 'Schreiben Sie hier Ihren Blogbeitrag...',
    selectCategory: 'Kategorie auswählen',
    featuredImage: 'Beitragsbild',
    uploadImage: 'Bild Hochladen',
    publishDate: 'Veröffentlichungsdatum',
    postExcerpt: 'Beitragsauszug',
    postExcerptPlaceholder: 'Kurze Zusammenfassung Ihres Beitrags...',
    tags: 'Tags',
    tagsPlaceholder: 'Tags durch Kommas getrennt hinzufügen',
    postPublished: 'Beitrag erfolgreich veröffentlicht',
    postSaved: 'Beitrag als Entwurf gespeichert',
    postDeleted: 'Beitrag erfolgreich gelöscht',

    // Manufacturer Onboarding
    manufacturerOnboarding: 'Hersteller-Onboarding',
    sourceDirectlyFromFactories: 'Beziehen Sie direkt von verifizierten Fabriken aus Ägypten',
    registerYourFactoryTitle: 'Registrieren Sie Ihre Fabrik',
    registerYourFactoryDesc: 'Treten Sie Ägyptens führender B2B-Textilfertigungsplattform bei. Reichen Sie Ihre Fabrikinformationen zur Verifizierung ein und beginnen Sie, sich mit globalen Käufern zu verbinden.',
    checkingAuthentication: 'Authentifizierung wird überprüft...',

    // Onboarding Steps
    companyInfo: 'Firmeninfo',
    factoryDetails: 'Fabrikdetails',
    yourProducts: 'Ihre Produkte',
    documents: 'Dokumente',
    subscription: 'Abonnement',

    // Step 1: Company Information
    companyInformation: 'Firmeninformationen',
    companyName: 'Firmenname',
    companyNamePlaceholder: 'EgypTex Manufacturing Co.',
    businessLicenseNumber: 'Gewerbelizenznummer',
    businessLicenseNumberPlaceholder: '12345678',
    establishedYear: 'Gründungsjahr',
    establishedYearPlaceholder: '2010',
    locationGovernorate: 'Standort (Gouvernement)',
    selectLocation: 'Standort auswählen',
    cairo: 'Kairo',
    alexandria: 'Alexandria',
    giza: 'Gizeh',
    tenthOfRamadan: '10. Ramadan',
    sixthOfOctober: '6. Oktober',
    borgElArab: 'Borg El Arab',
    other: 'Andere',
    fullAddress: 'Vollständige Adresse',
    fullAddressPlaceholder: 'Straße, Stadt, Postleitzahl',
    website: 'Webseite',
    websitePlaceholder: 'https://ihrefirma.com',
    phoneNumber: 'Telefonnummer',
    phoneNumberPlaceholder: '+20 XXX XXX XXXX',

    // Step 2: Factory Details
    factorySize: 'Fabrikgröße (qm)',
    factorySizePlaceholder: '5000',
    numberOfEmployees: 'Anzahl der Mitarbeiter',
    numberOfEmployeesPlaceholder: '150',
    productionCapacity: 'Produktionskapazität (pro Monat)',
    productionCapacityPlaceholder: '100.000 Meter Stoff',
    mainCategory: 'Hauptkategorie',
    selectMainCategory: 'Hauptkategorie auswählen',
    yarnAndSpinning: 'Garn & Spinnen',
    fabricsAndTextiles: 'Stoffe & Textilien',
    accessoriesAndTrims: 'Zubehör & Besätze',
    textileMachineryCategory: 'Textilmaschinen',
    others: 'Andere',

    // Step 3: Products
    productNumber: 'Produkt Nr.',
    productName: 'Produktname',
    productNamePlaceholder: '100% Ägyptischer Baumwollstoff',
    productDescription: 'Produktbeschreibung',
    productDescriptionPlaceholder: 'Detaillierte Beschreibung einschließlich Spezifikationen, Materialien, Verwendungen...',
    minimumOrderQuantity: 'Mindestbestellmenge',
    minimumOrderQuantityPlaceholder: '1000 Meter',
    priceRange: 'Preisspanne (Ägyptische Pfund - EGP)',
    priceRangePlaceholder: '$5 - $15 pro Meter',

    // Step 4: Documents
    documentsVerification: 'Dokumente & Verifizierung',
    requiredDocuments: 'Erforderliche Dokumente',
    businessLicensePdf: 'Gewerbeschein (PDF, max 5 MB)',
    certificationDocsOptional: 'Zertifizierungsdokumente (Optional, PDF)',
    productImagesDocs: 'Produktbilder (JPG/PNG, max 2 MB pro Bild)',
    businessLicense: 'Gewerbeschein',
    clickToUpload: 'Klicken Sie zum Hochladen oder ziehen Sie per Drag & Drop',
    pdfMax5mb: 'PDF (max 5 MB)',
    fileUploaded: 'Datei hochgeladen',
    certificationDocuments: 'Zertifizierungsdokumente (Optional)',
    uploadCertificates: 'Laden Sie Ihre Zertifikate hoch (ISO, OEKO-TEX, etc.)',
    pdfMax5mbMultiple: 'PDF (max 5 MB pro Datei, mehrere Dateien erlaubt)',
    filesSelected: 'Datei(en) ausgewählt',
    whatHappensNext: 'Was passiert als Nächstes?',
    verificationStep1: 'Unser Verifizierungsteam prüft Ihre Einreichung (2-3 Werktage)',
    verificationStep2: 'Wir kontaktieren Sie, falls zusätzliche Informationen benötigt werden',
    verificationStep3: 'Nach Genehmigung wird Ihr Fabrikprofil auf der Plattform live geschaltet',
    verificationStep4: 'Beginnen Sie, Anfragen von globalen Käufern zu erhalten',

    // Step 5: Subscription
    chooseYourPlan: 'Wählen Sie Ihren Plan',
    selectPlanDesc: 'Wählen Sie den Plan, der am besten zu Ihren Geschäftsanforderungen passt',
    monthly: 'Monatlich',
    yearly: 'Jährlich',
    saveTwoMonths: '2 Monate sparen',
    freePlan: 'Kostenloser Plan',
    freePlanArabic: 'الخطة المجانية',
    free: 'Kostenlos',
    freeArabic: 'مجاني',
    basicAccountCreation: 'Grundlegende Kontoerstellung',
    simpleCompanyProfile: 'Einfaches Firmenprofil',
    upTo3Products: 'Bis zu 3 Produkte',
    publicSearchResults: 'Öffentliche Suchergebnisse',
    threeInquiriesPerMonth: '3 Anfragen/Monat',
    emailSupportPlan: 'E-Mail-Support',
    standardPlan: 'Standard-Plan',
    standardPlanArabic: 'الخطة المدفوعة',
    popular: 'BELIEBT',
    egpMonthly: '1.000 EGP',
    egpMonthlyArabic: '1000 جنيه / شهريًا',
    egpYearly: '10.000 EGP',
    egpYearlyArabic: '10,000 جنيه / سنويًا',
    allFreeFeatures: 'Alle kostenlosen Funktionen',
    fullFactoryProfile: 'Vollständiges Fabrikprofil',
    upTo15Products: 'Bis zu 15 Produkte',
    unlimitedInquiries: 'Unbegrenzte Anfragen',
    directMessaging: 'Direktnachrichten',
    higherVisibility: 'Höhere Sichtbarkeit',
    applyToRfqs: 'Auf Ausschreibungen bewerben',
    prioritySupport: 'Prioritäts-Support',
    proPlan: 'Pro-Plan',
    proPlanArabic: 'الخطة الاحترافية',
    egpProMonthly: '2.000 EGP',
    egpProMonthlyArabic: '2000 جنيه / شهريًا',
    egpProYearly: '20.000 EGP',
    egpProYearlyArabic: '20,000 جنيه / سنويًا',
    allStandardFeatures: 'Alle Standard-Funktionen',
    unlimitedProducts: 'Unbegrenzte Produkte',
    topPrioritySearch: 'Top-Priorität in der Suche',
    verifiedSupplierBadge: 'Verifizierter Lieferant-Badge',
    homepageFeatured: 'Auf der Startseite hervorgehoben',
    performanceAnalyticsPlan: 'Leistungsanalysen',
    dedicatedSupport: 'Dedizierter Support',
    marketingCampaigns: 'Marketingkampagnen',
    importantNotes: 'Wichtige Hinweise',
    startFreeUpgradeAnytime: 'Sie können mit dem kostenlosen Plan beginnen und jederzeit upgraden',
    yearlySavings: 'Jahrespläne sparen Ihnen 2 Monate (Standard: 2.000 EGP | Pro: 4.000 EGP)',
    switchBillingAnytime: 'Wechseln Sie jederzeit zwischen monatlicher und jährlicher Abrechnung',
    allPlansIncludeVerification: 'Alle Pläne beinhalten unseren Verifizierungsprozess',
    paymentAfterApproval: 'Die Zahlung wird nach Genehmigung verarbeitet',
    yourSelection: 'Ihre Auswahl',
    plan: 'Plan',
    billing: 'Abrechnung',
    clickSubmitToComplete: 'Klicken Sie unten auf "Zur Überprüfung einreichen", um Ihre Registrierung abzuschließen',

    // Navigation Buttons
    previous: 'Zurück',
    nextStep: 'Nächster Schritt',
    submitForReview: 'Zur Überprüfung einreichen',
    submitting: 'Wird eingereicht...',
    backToHomepage: 'Zurück zur Startseite',

    // Required indicator
    required: '*',
  },

  es: {
    // Navigation
    home: 'Inicio',
    manufacturers: 'Fabricantes',
    products: 'Productos',
    more: 'Más',
    inquiries: 'Consultas',
    dashboard: 'Panel de Control',
    startSourcing: 'Comenzar Aprovisionamiento',

    // Homepage
    heroTagline: 'Abastécete directamente de fábricas verificadas de Egipto',
    heroTitle: 'Conéctate con Fabricantes Textiles Egipcios Verificados',
    heroSubtitle: 'Accede a algodón egipcio premium, tejidos técnicos y excelencia en manufactura. Únete a la principal puerta de enlace B2B para el aprovisionamiento textil global.',
    searchPlaceholder: 'Buscar fabricantes, productos o categorías...',
    searchButton: 'Buscar',
    exploreCategories: 'Explorar Categorías',

    // Egyptian Textile Categories
    yarnSpinning: 'Hilo y Hilado',
    yarnSpinningDesc: 'Hilo de algodón egipcio premium, poliéster, hilos mezclados y soluciones industriales de hilado',
    fabricsTextiles: 'Telas y Textiles',
    fabricsTextilesDesc: 'Telas tejidas, de punto, mezclilla, lona y tejidos técnicos de fabricantes egipcios',
    accessoriesTrims: 'Accesorios y Adornos',
    accessoriesTrimsDesc: 'Botones, cremalleras, etiquetas, cintas y accesorios textiles para la fabricación de prendas',
    textileMachinery: 'Maquinaria Textil',
    textileMachineryDesc: 'Máquinas de hilado, telares, equipos de teñido y maquinaria de producción textil',

    // Visitor Actions
    whatWouldYouLikeToDo: '¿Qué te gustaría hacer?',
    browseManufacturersAction: 'Explorar Fabricantes',
    browseProductsAction: 'Explorar Productos',
    sendInquiryAction: 'Enviar Consulta',
    orSearchDirectly: 'O buscar directamente:',

    // Featured Manufacturers
    featuredManufacturers: 'Fabricantes Verificados Destacados',
    featuredManufacturersDesc: 'Conéctate con fabricantes de primera categoría que han demostrado excelencia en calidad, confiabilidad y servicio al cliente.',
    verified: 'Verificado',
    productsCount: 'Productos',
    responseRate: 'Tasa de Respuesta',
    viewProfile: 'Ver Perfil',
    viewAllManufacturers: 'Ver Todos los Fabricantes',

    // Categories
    industryCategories: 'Categorías de Industria',
    categoriesDesc: 'Explora nuestra amplia gama de categorías textiles y manufactureras. Encuentra exactamente lo que necesitas con filtrado especializado.',
    totalCategories: 'Total de Categorías',
    totalProductsInCategories: 'Total de Productos',
    trending: 'Tendencias',
    allCategories: 'Todas las Categorías',
    searchCategories: 'Buscar categorías...',
    exploreCategory: 'Explorar Categoría',
    subcategories: 'Subcategorías',

    // Manufacturer Directory
    manufacturerDirectory: 'Directorio de Fabricantes',
    manufacturerDirectoryDesc: 'Conéctate con fabricantes y proveedores textiles egipcios verificados. Encuentra el socio perfecto para tus necesidades empresariales.',
    totalManufacturers: 'Total de Fabricantes',
    verifiedCompanies: 'Empresas Verificadas',
    activeProducts: 'Productos Activos',
    monthlyInquiries: 'Consultas Mensuales',
    searchManufacturers: 'Buscar fabricantes...',
    allLocations: 'Todas las Ubicaciones',
    showing: 'Mostrando',
    manufacturer: 'fabricante',
    manufacturers_plural: 'fabricantes',
    location: 'Ubicación',
    since: 'Desde',
    staff: 'Personal',
    rating: 'calificación',
    certifications: 'Certificaciones',
    noManufacturersFound: 'No se encontraron fabricantes',
    tryAdjustingFilters: 'Intenta ajustar tus criterios de búsqueda o filtros',

    // Product Catalog
    productCatalog: 'Catálogo de Productos',
    productCatalogDesc: 'Explora nuestra extensa colección de productos textiles verificados de fabricantes confiables.',
    filters: 'Filtros',
    sortBy: 'Ordenar Por',
    relevance: 'Relevancia',
    priceLowToHigh: 'Precio: Menor a Mayor',
    priceHighToLow: 'Precio: Mayor a Menor',
    newest: 'Más Reciente',
    searchProducts: 'Buscar productos...',
    minOrder: 'Pedido Mínimo',
    sendInquiry: 'Enviar Consulta',

    // Sign In
    signIn: 'Iniciar Sesión',
    welcomeBack: 'Bienvenido de Nuevo',
    signInDesc: 'Inicia sesión para acceder a tu panel de proveedor y gestionar tus operaciones comerciales.',
    email: 'Correo Electrónico',
    password: 'Contraseña',
    selectRole: 'Selecciona Tu Rol',
    owner: 'Propietario',
    admin: 'Administrador',
    ownerDesc: 'Acceso completo a todas las funciones',
    adminDesc: 'Gestionar operaciones',

    // Common
    category: 'Categoría',
    description: 'Descripción',
    noResultsFound: 'No se encontraron resultados',
    loading: 'Cargando...',
    error: 'Error',
    success: 'Éxito',
    cancel: 'Cancelar',
    save: 'Guardar',
    delete: 'Eliminar',
    edit: 'Editar',
    view: 'Ver',

    // Vendor Dashboard
    vendorDashboard: 'Panel de Proveedor',
    dashboardSubtitle: 'Gestiona tu perfil, productos y consultas desde una ubicación centralizada',
    overview: 'Resumen',
    analytics: 'Analíticas',
    profile: 'Perfil',
    settings: 'Configuración',
    navigation: 'Navegación',
    quickActions: 'Acciones Rápidas',
    needHelp: '¿Necesitas Ayuda?',
    helpDescription: 'Consulta nuestra documentación o contacta con soporte',
    viewDocs: 'Ver Documentos',

    // Dashboard Stats
    totalProducts: 'Total de Productos',
    activeInquiries: 'Consultas Activas',
    profileViews: 'Vistas de Perfil',
    profileCompletion: 'Compleción de Perfil',
    completeProfile: 'Completar Perfil',
    completeProfileDesc: 'Completa tu perfil para aumentar la visibilidad',
    missingInformation: 'Información Faltante:',

    // Performance & Notifications
    performanceAnalytics: 'Analíticas de Rendimiento',
    notifications: 'Notificaciones',
    all: 'Todas',
    approvals: 'Aprobaciones',
    system: 'Sistema',
    messages: 'Mensajes',
    noNotificationsFound: 'No se encontraron notificaciones',
    showLess: 'Mostrar Menos',
    viewAll: 'Ver Todas',

    // Inquiries Table
    recentInquiries: 'Consultas Recientes',
    buyer: 'Comprador',
    product: 'Producto',
    quantity: 'Cantidad',
    date: 'Fecha',
    priority: 'Prioridad',
    status: 'Estado',
    action: 'Acción',
    viewDetails: 'Ver Detalles',
    high: 'Alta',
    medium: 'Media',
    low: 'Baja',
    pending: 'Pendiente',
    responded: 'Respondido',
    closed: 'Cerrado',

    // Product Management
    productCatalogManager: 'Catálogo de Productos',
    addProduct: 'Agregar Producto',
    allStatus: 'Todos los Estados',
    active: 'Activo',
    inactive: 'Inactivo',
    stock: 'Inventario',
    price: 'Precio',

    // Quick Actions
    addNewProduct: 'Agregar Nuevo Producto',
    addNewProductDesc: 'Lista un nuevo producto en tu catálogo',
    manageInquiries: 'Gestionar Consultas',
    manageInquiriesDesc: 'Ver y responder a consultas de compradores',
    updateProfile: 'Actualizar Perfil',
    updateProfileDesc: 'Completa tu perfil de empresa',

    // CTA Section
    ctaTitle: '¿Listo para Transformar Tu Estrategia de Aprovisionamiento?',
    ctaSubtitle: 'Únete a miles de profesionales de compras que confían en EgypTex Gateway para conexiones confiables y basadas en datos con fabricantes.',
    browseManufacturers: 'Explorar Fabricantes',
    exploreProducts: 'Explorar Productos',
    trustedBy: 'Confiado por empresas líderes en todo el mundo',
    fortune500: 'Empresas Fortune 500',
    smeManufacturers: 'Fabricantes PYMES',
    internationalTraders: 'Comerciantes Internacionales',

    // Footer
    connectingManufacturers: 'Conectando fabricantes verificados con compradores globales a través de precisión basada en datos.',
    platform: 'Plataforma',
    resources: 'Recursos',
    company: 'Empresa',
    legal: 'Legal',
    sourcingGuide: 'Guía de Aprovisionamiento',
    qualityStandards: 'Estándares de Calidad',
    verificationProcess: 'Proceso de Verificación',
    helpCenter: 'Centro de Ayuda',
    aboutUs: 'Acerca de Nosotros',
    contact: 'Contacto',
    blog: 'Blog',
    privacyPolicy: 'Política de Privacidad',
    termsOfService: 'Términos de Servicio',
    cookiePolicy: 'Política de Cookies',
    gdprCompliance: 'Cumplimiento GDPR',
    allRightsReserved: 'Todos los derechos reservados',
    isoCertified: 'Certificado ISO 9001',
    gdprCompliant: 'Conforme GDPR',

    // Success Stories
    successStories: 'Historias de Éxito',
    successStoriesDesc: 'Resultados reales de empresas que transformaron su estrategia de aprovisionamiento con EgypTex Gateway.',
    challenge: 'Desafío',
    solution: 'Solución',
    results: 'Resultados',

    // Trust Indicators
    trustSecurity: 'Confianza y Seguridad',
    trustSecurityDesc: 'Tu éxito en aprovisionamiento se basa en nuestro compromiso con la transparencia, seguridad y garantía de calidad.',
    verifiedManufacturers: 'Fabricantes Verificados',
    verifiedManufacturersDesc: 'Cada fabricante pasa por una verificación rigurosa que incluye registro comercial, certificaciones y evaluaciones de capacidad.',
    securePlatform: 'Plataforma Segura',
    securePlatformDesc: 'Seguridad de nivel empresarial con cifrado SSL, cumplimiento GDPR y protocolos seguros de manejo de datos.',
    qualityAssurance: 'Garantía de Calidad',
    qualityAssuranceDesc: 'Plataforma certificada ISO 9001 con monitoreo continuo y procesos de control de calidad.',
    globalStandards: 'Estándares Globales',
    globalStandardsDesc: 'Cumplimiento de regulaciones comerciales internacionales y estándares de calidad específicos de la industria.',
    platformCertifications: 'Certificaciones y Cumplimiento de Plataforma',
    platformIso9001: 'ISO 9001:2015',
    platformSslSecured: 'Asegurado con SSL',
    platformSoc2: 'SOC 2 Tipo II',

    // Platform Metrics
    activeManufacturers: 'Fabricantes Activos',
    productListings: 'Listados de Productos',
    successfulConnections: 'Conexiones Exitosas',
    averageResponseTime: 'Tiempo Promedio de Respuesta',

    // Heritage Timeline
    ourHeritage: 'Nuestro Patrimonio',
    legacyWovenThroughTime: 'Un legado tejido a través del tiempo',
    heritageTimelineDesc: 'Desde telares antiguos hasta fábricas modernas, la tradición textil egipcia abarca milenios',
    ancientEgyptEra: 'Antiguo Egipto',
    ancientEgyptYear: '3000 a.C.',
    birthOfFineTextiles: 'El nacimiento de los textiles finos',
    birthOfFineTextilesDesc: 'Los artesanos egipcios fueron pioneros en técnicas de tejido de lino que producían telas tan finas que eran apreciadas en las civilizaciones antiguas. Los faraones usaban lino como símbolo de pureza y luz.',
    traditionalCraftsmanshipEra: 'Artesanía Tradicional',
    traditionalCraftsmanshipYear: '1000 - 1900 d.C.',
    generationsOfMastery: 'Generaciones de maestría',
    generationsOfMasteryDesc: 'A través de los siglos, los artesanos egipcios refinaron sus habilidades, transmitiendo técnicas de generación en generación. El hilado y tejido a mano siguieron siendo un arte de precisión y paciencia.',
    modernEra: 'Era Moderna',
    modernEraYear: '1900 - Presente',
    globalExcellenceManufacturing: 'Excelencia global en fabricación',
    globalExcellenceManufacturingDesc: 'El algodón egipcio de fibra larga se volvió legendario en todo el mundo. Hoy, combinamos la artesanía antigua con tecnología de vanguardia para producir textiles que cumplen con los más altos estándares internacionales.',

    // Egyptian Cotton Story
    theGoldStandard: 'El estándar de oro',
    egyptianLongStapleCotton: 'Algodón egipcio de fibra larga',
    egyptianCottonDesc: 'Cultivado en el fértil delta del Nilo, nuestro algodón es reconocido mundialmente por su longitud, resistencia y suavidad excepcionales',
    extraLongStaple: 'Fibra extra larga',
    extraLongStapleDesc: 'Fibras que miden 1.5-2 pulgadas crean una suavidad y durabilidad incomparables',
    superiorStrength: 'Resistencia superior',
    superiorStrengthDesc: 'Fibras más fuertes significan telas que duran más y resisten el pilling',
    naturalLuster: 'Brillo natural',
    naturalLusterDesc: 'Brillo y suavidad únicos que mejoran con cada lavado',
    giftFromNile: 'Un regalo del Nilo',
    giftFromNileDesc1: 'El rico suelo aluvial del delta del Nilo, combinado con el clima único de Egipto, crea las condiciones perfectas para cultivar Gossypium barbadense, la mejor variedad de algodón del mundo.',
    giftFromNileDesc2: 'Desde la antigüedad, los textiles egipcios han sido apreciados en todas las civilizaciones. Los faraones envolvían sus momias en lino fino, y hoy, las marcas de lujo del mundo buscan algodón egipcio por su calidad inigualable.',
    giftFromNileDesc3: 'Cuando eliges textiles egipcios, estás eligiendo un legado de excelencia que abarca milenios.',
    meetOurManufacturers: 'Conoce a nuestros fabricantes',
    yearsOfHeritage: 'Años de patrimonio',
    fiberLength: 'Longitud de fibra',
    naturalPure: 'Natural y puro',
    globalQuality: 'Calidad global',

    // Search Modal
    searchModalTitle: '¿Qué te gustaría encontrar?',
    searchModalPlaceholder: 'Buscar fabricantes, productos, categorías...',
    recentSearches: 'Búsquedas recientes',
    popularSearches: 'Búsquedas populares',
    quickLinks: 'Enlaces rápidos',
    clearSearch: 'Limpiar',
    noRecentSearches: 'No hay búsquedas recientes',

    // Industry Categories (Additional)
    browseByIndustry: 'Explorar por industria',
    viewAllCategories: 'Ver todas las categorías',

    // Common UI
    language: 'Idioma',
    theme: 'Tema',
    light: 'Claro',
    dark: 'Oscuro',

    // Product Catalog
    searchProductsPlaceholder: 'Buscar productos por nombre, categoría o especificaciones...',
    browseProductsDesc: 'Explora nuestra base de datos completa de productos y equipos industriales',
    productCatalogTitle: 'Catálogo de Productos',
    productCatalogCount: 'Productos',

    // Manufacturer Directory Specific
    searchManufacturersPlaceholder: 'Buscar fabricantes por nombre, productos o especialización...',

    // Help Center
    supportAvailable: 'Soporte 24/7',
    helpCenterDesc: 'Encuentra respuestas a preguntas comunes y obtén el soporte que necesitas',
    searchForHelp: 'Buscar ayuda...',
    faqTitle: 'Preguntas Frecuentes',
    faqHowToFind: '¿Cómo encuentro fabricantes en la plataforma?',
    faqHowToFindAnswer: 'Usa nuestra función de búsqueda para explorar fabricantes por categoría, ubicación o especialización. Filtra resultados según certificaciones y calificaciones.',
    faqVerified: '¿Todos los fabricantes están verificados?',
    faqVerifiedAnswer: 'Sí, cada fabricante pasa por nuestro riguroso proceso de verificación que incluye registro comercial, certificaciones e inspecciones de instalaciones.',
    faqRequestQuote: '¿Cómo solicito una cotización?',
    faqRequestQuoteAnswer: 'Visita el perfil de un fabricante y haz clic en "Enviar Consulta". Proporciona tus requisitos y el fabricante responderá directamente.',
    faqPayment: '¿Qué métodos de pago se aceptan?',
    faqPaymentAnswer: 'Los términos de pago se negocian directamente entre tú y el fabricante. Recomendamos usar métodos de pago seguros.',
    stillNeedHelp: '¿Aún Necesitas Ayuda?',
    contactSupportTeam: 'Contacta con nuestro equipo de soporte',
    emailSupport: 'Soporte por Correo',
    phoneSupport: 'Soporte Telefónico',

    // Sourcing Guide
    sourcingGuideTitle: 'Guía de Aprovisionamiento',
    sourcingGuideSubtitle: 'Tu hoja de ruta completa para encontrar y trabajar con los socios de fabricación perfectos',
    comprehensiveGuide: 'Guía Completa',
    theSourcingProcess: 'El Proceso de Aprovisionamiento',
    defineRequirements: 'Define Tus Requisitos',
    defineRequirementsDesc: 'Comienza describiendo claramente tus especificaciones de producto, estándares de calidad, MOQ, rango presupuestario y cronograma de entrega. Cuanto más detallados sean tus requisitos, mejores coincidencias encontrarás.',
    searchFilter: 'Buscar y Filtrar',
    searchFilterDesc: 'Utiliza nuestras potentes herramientas de búsqueda y filtros avanzados para reducir los fabricantes por categoría, ubicación, certificaciones, capacidad de producción y especializaciones.',
    verifyCompare: 'Verificar y Comparar',
    verifyCompareDesc: 'Revisa los perfiles de fabricantes, verifica certificaciones, consulta calificaciones y reseñas, compara capacidades y evalúa su historial con compradores anteriores.',
    requestQuotes: 'Solicitar Cotizaciones',
    requestQuotesDesc: 'Contacta con múltiples fabricantes a través de nuestra plataforma, solicita cotizaciones detalladas, negocia términos y pide muestras para evaluar la calidad antes de tomar decisiones.',
    bestPractices: 'Mejores Prácticas',
    verifyCredentials: 'Verificar Credenciales',
    verifyCredentialsDesc: 'Siempre verifica las licencias comerciales y certificaciones',
    reviewSamples: 'Revisar Muestras',
    reviewSamplesDesc: 'Solicita muestras de productos antes de realizar pedidos grandes',
    clearCommunication: 'Comunicación Clara',
    clearCommunicationDesc: 'Mantén una comunicación documentada y transparente',
    compareOptions: 'Comparar Opciones',
    compareOptionsDesc: 'Obtén cotizaciones de múltiples fabricantes',
    writtenAgreements: 'Acuerdos Escritos',
    writtenAgreementsDesc: 'Siempre formaliza los acuerdos por escrito',
    setTimelines: 'Establecer Cronogramas',
    setTimelinesDesc: 'Establece plazos y hitos claros',
    readyToStartSourcing: '¿Listo para Comenzar el Aprovisionamiento?',
    browseMfgDirectory: 'Explora nuestro directorio de fabricantes verificados y conéctate con proveedores confiables',

    // Quality Standards
    qualityStandardsTitle: 'Estándares de Calidad',
    qualityStandardsSubtitle: 'Mantenemos estándares de calidad rigurosos para garantizar que todos los fabricantes cumplan con los requisitos internacionales',
    certifiedStandards: 'Estándares Certificados',
    requiredCertifications: 'Certificaciones Requeridas',
    iso9001: 'ISO 9001:2015',
    iso9001Desc: 'Sistemas de Gestión de Calidad',
    iso14001: 'ISO 14001',
    iso14001Desc: 'Gestión Ambiental',
    oekoTex: 'OEKO-TEX Standard 100',
    oekoTexDesc: 'Seguridad de Productos Textiles',
    gots: 'GOTS',
    gotsDesc: 'Estándar Global de Textiles Orgánicos',
    bci: 'BCI',
    bciDesc: 'Iniciativa del Mejor Algodón',
    wrap: 'WRAP',
    wrapDesc: 'Producción Responsable Mundial',
    ourQualityProcess: 'Nuestro Proceso de Control de Calidad',
    initialVerification: 'Verificación Inicial',
    initialVerificationDesc: 'Revisión de documentos y verificación de registro comercial',
    facilityInspection: 'Inspección de Instalaciones',
    facilityInspectionDesc: 'Evaluación in situ de las capacidades de producción',
    sampleTesting: 'Prueba de Muestras',
    sampleTestingDesc: 'Evaluación de calidad de muestras de productos',
    ongoingMonitoring: 'Monitoreo Continuo',
    ongoingMonitoringDesc: 'Seguimiento continuo del rendimiento y recertificación',
    committedToExcellence: 'Comprometidos con la Excelencia',
    committedToExcellenceDesc: 'Cada fabricante en nuestra plataforma se somete a una verificación exhaustiva y monitoreo continuo para garantizar que se mantengan los más altos estándares de calidad durante toda tu asociación.',

    // Verification Process
    verificationProcessTitle: 'Proceso de Verificación',
    verificationProcessSubtitle: 'Nuestra verificación integral de 6 pasos garantiza que te conectes con fabricantes creíbles y capaces',
    rigorousVerification: 'Verificación Rigurosa',
    businessRegistration: 'Verificación de Registro Comercial',
    businessRegistrationDesc: 'Verificamos documentos oficiales de registro comercial, certificados fiscales y situación legal para garantizar la legitimidad.',
    certificationValidation: 'Validación de Certificaciones',
    certificationValidationDesc: 'Todas las certificaciones de calidad, credenciales de la industria y documentos de cumplimiento se verifican y validan minuciosamente.',
    facilityInspectionTitle: 'Inspección de Instalaciones',
    facilityInspectionDesc2: 'Visitas in situ para evaluar las capacidades de producción, sistemas de control de calidad y condiciones laborales.',
    capabilityAssessment: 'Evaluación de Capacidades',
    capabilityAssessmentDesc: 'Evaluación de la capacidad de producción, capacidades técnicas, equipamiento y procesos de fabricación.',
    performanceMonitoring: 'Monitoreo de Rendimiento',
    performanceMonitoringDesc: 'Seguimiento continuo del rendimiento del fabricante, comentarios de compradores y métricas de calidad.',
    periodicReverification: 'Reverificación Periódica',
    periodicReverificationDesc: 'Reevaluación regular y renovación del estado de verificación para mantener los estándares de calidad.',
    verifiedBadge: 'Insignia Verificada',
    verifiedBadgeDesc: 'Los fabricantes que completan con éxito nuestro proceso de verificación reciben una insignia verificada, brindándote confianza en su credibilidad y capacidades.',

    // Blog
    blogTitle: 'Blog',
    blogSubtitle: 'Perspectivas, noticias y actualizaciones del mundo del aprovisionamiento textil',
    industryInsights: 'Perspectivas de la Industria',
    sourcingTips: 'Consejos de Aprovisionamiento',
    qualityAssuranceCategory: 'Aseguramiento de Calidad',
    readMore: 'Leer Más',
    blogPost1Title: 'El Futuro de la Fabricación Textil Egipcia',
    blogPost1Excerpt: 'Explorando tendencias e innovaciones que dan forma a la industria textil de Egipto...',
    blogPost2Title: 'Cómo Elegir el Fabricante Textil Adecuado',
    blogPost2Excerpt: 'Una guía completa para evaluar y seleccionar socios de fabricación...',
    blogPost3Title: 'Estándares de Calidad en la Producción Textil',
    blogPost3Excerpt: 'Comprender las certificaciones de calidad internacionales y su importancia...',

    // Privacy Policy
    privacyPolicyTitle: 'Política de Privacidad',
    lastUpdated: 'Última actualización',
    informationWeCollect: '1. Información que Recopilamos',
    informationWeCollectDesc: 'Recopilamos información que nos proporcionas directamente, incluido nombre, dirección de correo electrónico, información de la empresa y cualquier otra información que elijas proporcionar.',
    howWeUseInfo: '2. Cómo Usamos Tu Información',
    howWeUseInfoDesc: 'Utilizamos la información que recopilamos para:',
    howWeUseInfo1: 'Proporcionar, mantener y mejorar nuestros servicios',
    howWeUseInfo2: 'Procesar y completar transacciones',
    howWeUseInfo3: 'Enviarte avisos técnicos y mensajes de soporte',
    howWeUseInfo4: 'Responder a tus comentarios y preguntas',
    howWeUseInfo5: 'Monitorear y analizar tendencias, uso y actividades',
    informationSharing: '3. Compartir Información',
    informationSharingDesc: 'No compartimos tu información personal con terceros excepto como se describe en esta política o con tu consentimiento.',
    dataSecurity: '4. Seguridad de Datos',
    dataSecurityDesc: 'Tomamos medidas razonables para ayudar a proteger tu información personal contra pérdida, robo, uso indebido, acceso no autorizado, divulgación, alteración y destrucción.',
    yourRights: '5. Tus Derechos',
    yourRightsDesc: 'Tienes derecho a acceder, actualizar o eliminar tu información personal en cualquier momento. Contáctanos para obtener ayuda.',
    contactUsPolicy: '6. Contáctanos',
    contactUsPolicyDesc: 'Si tienes preguntas sobre esta Política de Privacidad, contáctanos en',

    // Terms of Service
    termsOfServiceTitle: 'Términos de Servicio',
    acceptanceOfTerms: '1. Aceptación de Términos',
    acceptanceOfTermsDesc: 'Al acceder y usar EgypTex Gateway, aceptas y acuerdas estar sujeto a los términos y disposiciones de este acuerdo.',
    useOfService: '2. Uso del Servicio',
    useOfServiceDesc: 'Aceptas usar el servicio solo para fines legales y de acuerdo con estos Términos. Aceptas no usar el servicio:',
    useOfService1: 'De cualquier manera que viole las leyes o regulaciones aplicables',
    useOfService2: 'Para transmitir cualquier contenido ilegal, dañino u objetable',
    useOfService3: 'Para hacerse pasar o intentar hacerse pasar por otra persona o entidad',
    useOfService4: 'Para participar en cualquier conducta que restrinja el uso del servicio por parte de cualquier persona',
    userAccounts: '3. Cuentas de Usuario',
    userAccountsDesc: 'Cuando creas una cuenta, debes proporcionar información precisa y completa. Eres responsable de mantener la confidencialidad de las credenciales de tu cuenta.',
    intellectualProperty: '4. Propiedad Intelectual',
    intellectualPropertyDesc: 'El servicio y su contenido, características y funcionalidad originales son propiedad de EgypTex Gateway y están protegidos por leyes internacionales de derechos de autor, marcas registradas y otras leyes de propiedad intelectual.',
    limitationOfLiability: '5. Limitación de Responsabilidad',
    limitationOfLiabilityDesc: 'En ningún caso EgypTex Gateway será responsable de daños indirectos, incidentales, especiales, consecuentes o punitivos resultantes de tu uso del servicio.',
    contactInfoLegal: '6. Información de Contacto',
    contactInfoLegalDesc: 'Para preguntas sobre estos Términos, contáctanos en',

    // Cookie Policy
    cookiePolicyTitle: 'Política de Cookies',
    whatAreCookies: 'Qué son las Cookies',
    whatAreCookiesDesc: 'Las cookies son pequeños archivos de texto que se colocan en tu dispositivo cuando visitas un sitio web. Se utilizan ampliamente para hacer que los sitios web funcionen de manera más eficiente y proporcionar información a los propietarios del sitio.',
    howWeUseCookies: 'Cómo Usamos las Cookies',
    howWeUseCookiesDesc: 'Utilizamos cookies para los siguientes propósitos:',
    essentialCookies: 'Cookies Esenciales:',
    essentialCookiesDesc: 'Requeridas para que el sitio web funcione correctamente',
    analyticsCookies: 'Cookies Analíticas:',
    analyticsCookiesDesc: 'Nos ayudan a comprender cómo los visitantes interactúan con nuestro sitio web',
    preferenceCookies: 'Cookies de Preferencias:',
    preferenceCookiesDesc: 'Recuerdan tus configuraciones y preferencias',
    marketingCookies: 'Cookies de Marketing:',
    marketingCookiesDesc: 'Rastrean a los visitantes en sitios web para mostrar anuncios relevantes',
    managingCookies: 'Gestión de Cookies',
    managingCookiesDesc: 'La mayoría de los navegadores web te permiten controlar las cookies a través de su configuración. Sin embargo, si limitas la capacidad de los sitios web para establecer cookies, puedes afectar tu experiencia general como usuario.',
    thirdPartyCookies: 'Cookies de Terceros',
    thirdPartyCookiesDesc: 'Podemos usar proveedores de servicios de terceros para monitorear y analizar el uso de nuestro servicio. Estos terceros tienen sus propias políticas de privacidad que abordan cómo usan dicha información.',

    // GDPR Compliance
    gdprComplianceTitle: 'Cumplimiento GDPR',
    gdprComplianceSubtitle: 'Comprometidos a proteger tu privacidad y garantizar el cumplimiento del GDPR',
    gdprCompliantBadge: 'Conforme con GDPR',
    yourRightsUnderGDPR: 'Tus Derechos Bajo GDPR',
    rightToAccess: 'Derecho de Acceso',
    rightToAccessDesc: 'Solicitar copias de tus datos personales',
    rightToRectification: 'Derecho de Rectificación',
    rightToRectificationDesc: 'Solicitar la corrección de datos inexactos o incompletos',
    rightToErasure: 'Derecho al Borrado',
    rightToErasureDesc: 'Solicitar la eliminación de tus datos personales',
    rightToDataPortability: 'Derecho a la Portabilidad de Datos',
    rightToDataPortabilityDesc: 'Solicitar la transferencia de tus datos a otra organización',
    dataProtectionMeasures: 'Medidas de Protección de Datos',
    dataProtection1: 'Cifrado de datos en tránsito y en reposo',
    dataProtection2: 'Auditorías de seguridad y evaluaciones regulares',
    dataProtection3: 'Capacitación del personal sobre protección de datos',
    dataProtection4: 'Controles de acceso y autenticación estrictos',
    dataProtection5: 'Procedimientos de notificación de violación de datos',
    contactDPO: 'Contacta con Nuestro Oficial de Protección de Datos',
    contactDPODesc: 'Para cualquier consulta relacionada con GDPR o para ejercer tus derechos, contacta con nuestro DPO:',

    // Blog Management
    blogManagement: 'Gestión de Blog',
    blogManagementDesc: 'Crear y gestionar tus publicaciones de blog',
    createNewPost: 'Crear Nueva Publicación',
    editPost: 'Editar Publicación',
    deletePost: 'Eliminar Publicación',
    publishPost: 'Publicar',
    draftPost: 'Guardar como Borrador',
    postTitle: 'Título de la Publicación',
    postContent: 'Contenido de la Publicación',
    postCategory: 'Categoría',
    postStatus: 'Estado',
    published: 'Publicado',
    draft: 'Borrador',
    scheduled: 'Programado',
    postDate: 'Fecha de Publicación',
    author: 'Autor',
    views: 'Vistas',
    comments: 'Comentarios',
    editBlogPost: 'Editar Publicación',
    deleteBlogPost: 'Eliminar Publicación',
    noBlogPostsFound: 'No se encontraron publicaciones',
    createFirstPost: 'Crea tu primera publicación para comenzar',
    postTitlePlaceholder: 'Ingresa el título de la publicación...',
    postContentPlaceholder: 'Escribe el contenido de tu publicación aquí...',
    selectCategory: 'Selecciona una categoría',
    featuredImage: 'Imagen Destacada',
    uploadImage: 'Subir Imagen',
    publishDate: 'Fecha de Publicación',
    postExcerpt: 'Extracto de la Publicación',
    postExcerptPlaceholder: 'Breve resumen de tu publicación...',
    tags: 'Etiquetas',
    tagsPlaceholder: 'Agrega etiquetas separadas por comas',
    postPublished: 'Publicación publicada exitosamente',
    postSaved: 'Publicación guardada como borrador',
    postDeleted: 'Publicación eliminada exitosamente',

    // Manufacturer Onboarding
    manufacturerOnboarding: 'Registro de Fabricante',
    sourceDirectlyFromFactories: 'Abastécete directamente de fábricas verificadas de Egipto',
    registerYourFactoryTitle: 'Registra Tu Fábrica',
    registerYourFactoryDesc: 'Únete a la principal plataforma B2B de fabricación textil de Egipto. Envía la información de tu fábrica para verificación y comienza a conectarte con compradores globales.',
    checkingAuthentication: 'Verificando autenticación...',

    // Onboarding Steps
    companyInfo: 'Info de Empresa',
    factoryDetails: 'Detalles de Fábrica',
    yourProducts: 'Tus Productos',
    documents: 'Documentos',
    subscription: 'Suscripción',

    // Step 1: Company Information
    companyInformation: 'Información de la Empresa',
    companyName: 'Nombre de la Empresa',
    companyNamePlaceholder: 'EgypTex Manufacturing Co.',
    businessLicenseNumber: 'Número de Licencia Comercial',
    businessLicenseNumberPlaceholder: '12345678',
    establishedYear: 'Año de Establecimiento',
    establishedYearPlaceholder: '2010',
    locationGovernorate: 'Ubicación (Gobernación)',
    selectLocation: 'Seleccionar ubicación',
    cairo: 'El Cairo',
    alexandria: 'Alejandría',
    giza: 'Guiza',
    tenthOfRamadan: '10 de Ramadán',
    sixthOfOctober: '6 de Octubre',
    borgElArab: 'Borg El Arab',
    other: 'Otro',
    fullAddress: 'Dirección Completa',
    fullAddressPlaceholder: 'Calle, ciudad, código postal',
    website: 'Sitio Web',
    websitePlaceholder: 'https://tuempresa.com',
    phoneNumber: 'Número de Teléfono',
    phoneNumberPlaceholder: '+20 XXX XXX XXXX',

    // Step 2: Factory Details
    factorySize: 'Tamaño de la Fábrica (m²)',
    factorySizePlaceholder: '5000',
    numberOfEmployees: 'Número de Empleados',
    numberOfEmployeesPlaceholder: '150',
    productionCapacity: 'Capacidad de Producción (por mes)',
    productionCapacityPlaceholder: '100,000 metros de tela',
    mainCategory: 'Categoría Principal',
    selectMainCategory: 'Seleccionar categoría principal',
    yarnAndSpinning: 'Hilo e Hilado',
    fabricsAndTextiles: 'Telas y Textiles',
    accessoriesAndTrims: 'Accesorios y Adornos',
    textileMachineryCategory: 'Maquinaria Textil',
    others: 'Otros',

    // Step 3: Products
    productNumber: 'Producto n°',
    productName: 'Nombre del Producto',
    productNamePlaceholder: 'Tela de Algodón Egipcio 100%',
    productDescription: 'Descripción del Producto',
    productDescriptionPlaceholder: 'Descripción detallada incluyendo especificaciones, materiales, usos...',
    minimumOrderQuantity: 'Cantidad Mínima de Pedido',
    minimumOrderQuantityPlaceholder: '1000 metros',
    priceRange: 'Rango de Precio (Libras Egipcias - EGP)',
    priceRangePlaceholder: '$5 - $15 por metro',

    // Step 4: Documents
    documentsVerification: 'Documentos y Verificación',
    requiredDocuments: 'Documentos Requeridos',
    businessLicensePdf: 'Licencia Comercial (PDF, máx 5 MB)',
    certificationDocsOptional: 'Documentos de Certificación (Opcional, PDF)',
    productImagesDocs: 'Imágenes de Productos (JPG/PNG, máx 2 MB cada una)',
    businessLicense: 'Licencia Comercial',
    clickToUpload: 'Haz clic para cargar o arrastra y suelta',
    pdfMax5mb: 'PDF (máx 5 MB)',
    fileUploaded: 'Archivo cargado',
    certificationDocuments: 'Documentos de Certificación (Opcional)',
    uploadCertificates: 'Sube tus certificados (ISO, OEKO-TEX, etc.)',
    pdfMax5mbMultiple: 'PDF (máx 5 MB cada uno, se permiten múltiples archivos)',
    filesSelected: 'archivo(s) seleccionado(s)',
    whatHappensNext: '¿Qué sucede después?',
    verificationStep1: 'Nuestro equipo de verificación revisa tu envío (2-3 días hábiles)',
    verificationStep2: 'Te contactaremos si se necesita información adicional',
    verificationStep3: 'Una vez aprobado, tu perfil de fábrica se publicará en la plataforma',
    verificationStep4: 'Comienza a recibir consultas de compradores globales',

    // Step 5: Subscription
    chooseYourPlan: 'Elige Tu Plan',
    selectPlanDesc: 'Selecciona el plan que mejor se adapte a las necesidades de tu negocio',
    monthly: 'Mensual',
    yearly: 'Anual',
    saveTwoMonths: 'Ahorra 2 meses',
    freePlan: 'Plan Gratuito',
    freePlanArabic: 'الخطة المجانية',
    free: 'Gratis',
    freeArabic: 'مجاني',
    basicAccountCreation: 'Creación de cuenta básica',
    simpleCompanyProfile: 'Perfil de empresa simple',
    upTo3Products: 'Hasta 3 productos',
    publicSearchResults: 'Resultados de búsqueda públicos',
    threeInquiriesPerMonth: '3 consultas/mes',
    emailSupportPlan: 'Soporte por correo electrónico',
    standardPlan: 'Plan Estándar',
    standardPlanArabic: 'الخطة المدفوعة',
    popular: 'POPULAR',
    egpMonthly: '1,000 EGP',
    egpMonthlyArabic: '1000 جنيه / شهريًا',
    egpYearly: '10,000 EGP',
    egpYearlyArabic: '10,000 جنيه / سنويًا',
    allFreeFeatures: 'Todas las características gratuitas',
    fullFactoryProfile: 'Perfil de fábrica completo',
    upTo15Products: 'Hasta 15 productos',
    unlimitedInquiries: 'Consultas ilimitadas',
    directMessaging: 'Mensajería directa',
    higherVisibility: 'Mayor visibilidad',
    applyToRfqs: 'Aplicar a licitaciones',
    prioritySupport: 'Soporte prioritario',
    proPlan: 'Plan Pro',
    proPlanArabic: 'الخطة الاحترافية',
    egpProMonthly: '2,000 EGP',
    egpProMonthlyArabic: '2000 جنيه / شهريًا',
    egpProYearly: '20,000 EGP',
    egpProYearlyArabic: '20,000 جنيه / سنويًا',
    allStandardFeatures: 'Todas las características estándar',
    unlimitedProducts: 'Productos ilimitados',
    topPrioritySearch: 'Búsqueda de máxima prioridad',
    verifiedSupplierBadge: 'Insignia de Proveedor Verificado',
    homepageFeatured: 'Destacado en la página de inicio',
    performanceAnalyticsPlan: 'Análisis de rendimiento',
    dedicatedSupport: 'Soporte dedicado',
    marketingCampaigns: 'Campañas de marketing',
    importantNotes: 'Notas Importantes',
    startFreeUpgradeAnytime: 'Puedes comenzar con el plan gratuito y actualizar en cualquier momento',
    yearlySavings: 'Los planes anuales te ahorran 2 meses (Estándar: 2,000 EGP | Pro: 4,000 EGP)',
    switchBillingAnytime: 'Cambia entre facturación mensual y anual en cualquier momento',
    allPlansIncludeVerification: 'Todos los planes incluyen nuestro proceso de verificación',
    paymentAfterApproval: 'El pago se procesará después de la aprobación',
    yourSelection: 'Tu Selección',
    plan: 'Plan',
    billing: 'Facturación',
    clickSubmitToComplete: 'Haz clic en "Enviar para Revisión" a continuación para completar tu registro',

    // Navigation Buttons
    previous: 'Anterior',
    nextStep: 'Siguiente Paso',
    submitForReview: 'Enviar para Revisión',
    submitting: 'Enviando...',
    backToHomepage: 'Volver al Inicio',

    // Required indicator
    required: '*',
  }
};

export type Language = keyof typeof translations;
export type TranslationKey = keyof typeof translations.en;

export function getTranslation(lang: Language, key: TranslationKey): string {
  return (translations[lang] as Record<string, string>)?.[key] || (translations.en as Record<string, string>)[key] || key;
}
